/* diamond detail box */
const DiamondDetailBox = {
  data() {
    return {
      showLoader: false,
    };
  },
  props: ["diamond"],
  emits: ["closeDiamondDetailBox"],
  delimiters: ["[[", "]]"],
  template: `#diamond-detail-box`,
  mounted() {
    this.showLoader = true;
  },
  computed: {
    getTitle() {
      return (diamond) => {
        return getDiamondTitle(diamond);
      };
    },
  },
  methods: {
    openDiamondDetailPage(diamondId, diamondType) {
      this.$router.push({
        name: "diamondDetailPage",
        params: { diamondId, diamondTab: diamondType },
      });
    },
    hideLoader() {
      this.showLoader = false;
    },
    setPlaceholderImg(imgElement, diamond) {
      imgElement.setAttribute(
        "src",
        diamond.diamondType != "gemstone"
          ? `${baseUrl}/cdn/shop/t/9/assets/${diamond.shape}.png`
          : getGemstoneSampleImg(diamond)
      );
    },
  },
};

/* diamond video popup component */
const DiamondVideoPopupComp = {
  props: ["videoUrl"],
  emits: ["closePopup"],
  delimiters: ["[[", "]]"],
  template: `#diamond-video-popup-comp`,
  data() {
    return {
      showLoader: false,
    };
  },
  watch: {
    showLoader: {
      handler(showLoader) {
        this.hideLoader();
      },
    },
  },
  mounted() {
    this.showLoader = true;
  },
  methods: {
    hideLoader() {
      var timeoutId = setTimeout(() => {
        this.showLoader = false;
        clearTimeout(timeoutId);
      }, 5000);
    },
  },
};

/*list view grid component */
const ListViewComp = {
  components: {
    SpinnerComp,
    DiamondDetailBox,
    DiamondVideoPopupComp,
  },
  fieldsToParse: ["carat_weight", "dept_perc", "table_perc"],
  setup(props, context) {
    const diamondCompareState = inject("diamondsForCompare");
    const currentGridTab = inject("currentGridTab");
    function sendDiamondsForCompare(e, diamondObj) {
      e.stopPropagation();
      e.preventDefault();
      context.emit("pCompareDiamonds", e.target.checked, diamondObj);
      context.emit("pHandleTooltip", e.target.checked);
    }
    return {
      ...toRefs(currentGridTab),
      sendDiamondsForCompare,
      ...toRefs(diamondCompareState),
    };
  },
  data() {
    return {
      diamondIdToShow: "",
      diamondVideoUrl: "",
    };
  },
  props: [
    "items",
    "diamondCount",
    "currentPage",
    "pageLimit",
    "fieldsToSort",
    "sortColumnsWidth",
    "isLoading",
    "defaultSort",
    "diamondType",
  ],
  emits: [
    "loadMoreItems",
    "listSort",
    "pCompareDiamonds",
    "pHandleTooltip",
    "imageError",
  ],
  delimiters: ["[[", "]]"],
  template: `#list-view-result`,
  computed: {
    getPlaceholderImage() {
      return (diamond) => {
        return diamond.diamondType != "gemstone"
          ? getShapeFallbackImage(diamond.shape)
          : getGemstoneSampleImg(diamond);
      };
    },
  },
  watch: {
    "$props.items": {
      handler(diamondList) {
        if (!diamondList.length) {
          this.diamondIdToShow = "";
        }
      },
    },
  },
  methods: {
    handleDiamondImgError(e, shape) {
      var target = e.target || e.currentTarget;
      var fallback = getShapeFallbackImage(shape);
      target.removeAttribute("srcset");
      if (target.src === shapeToImageUrl.DEFAULT) return;
      if (target.src === fallback) {
        target.src = shapeToImageUrl.DEFAULT;
      } else {
        target.src = fallback;
      }
    },
    showDiamondDetailBox(diamondId) {
      if (this.diamondIdToShow && this.diamondIdToShow == diamondId) {
        this.diamondIdToShow = "";
      } else {
        this.diamondIdToShow = diamondId;
      }
    },
    sort(e, sortType, sortDir, currentTab, isAdvanceField) {
      if (currentTab != "diamond" || isAdvanceField) return;
      this.$emit("listSort", sortType, sortDir == "ASC" ? "DESC" : "ASC");
    },
    showPage(e, diamondId) {
      if (
        e.target.tagName.toLowerCase() == "input" ||
        e.target.classList.contains("list-item-enable-video") ||
        e.target.closest(".pc-diamond-grid-info-block")
      ) {
        return;
      }
      this.showDiamondDetailBox(diamondId);
    },
    openVideoPopup(videoUrl) {
      this.diamondVideoUrl = videoUrl;
    },
  },
};

/*grid view component */
const GridViewComp = {
  components: {
    SpinnerComp,
    DiamondDetailPopupComp,
  },
  setup(props, context) {
    const diamondCompareState = inject("diamondsForCompare");
    const currentGridTab = inject("currentGridTab");
    const diamondDataState = reactive({
      diamondId: "",
    });
    provide("diamondDataState", diamondDataState);
    function showDetailPopup(e, diamondId) {
      e.stopPropagation();
      diamondDataState.diamondId =
        diamondDataState.diamondId == diamondId ? "" : diamondId;
    }
    function sendDiamondsForCompare(e, diamondObj, array) {
      let checked = true;
      if (array.length) {
        checked = array.some((obj) => obj === diamondObj.diamondId);
      }
      context.emit("pCompareDiamonds", checked, diamondObj);
      context.emit("pHandleTooltip", checked, diamondObj);
    }

    return {
      showDetailPopup,
      sendDiamondsForCompare,
      ...toRefs(currentGridTab),
      ...toRefs(diamondCompareState),
      ...toRefs(diamondDataState),
    };
  },
  data() {
    return {
      loadingGIF: `${baseAssetsUrl}/loading.gif`,
      compareDiamond: [],
      compareDiamondIds: [],
      isTooltipVisible: "",
      bannerTwoIndex: [],
      bannerThreeIndex: [],
      bannerFourIndex: [],
      productDivClass: "",
      bannerNameArray: [],
      isLabGrownPopupModal: null,
    };
  },
  props: [
    "compareDiamonds",
    "items",
    "compareArray",
    "diamondCount",
    "currentPage",
    "pageLimit",
    "isLoading",
    "wishlistItems",
    "diamondType",
  ],
  emits: [
    "addDiamondToCompare",
    "loadMoreItems",
    "pCompareDiamonds",
    "pHandleTooltip",
    "addToWishlistParent",
    "imageError",
  ],
  delimiters: ["[[", "]]"],
  template: `#grid-view-result`,
  watch: {
    diamondCount() {
      const width = window.innerWidth;
      if (this.filteredBanners.length === 0) {
        this.bannerTwoIndex = [];
        this.bannerThreeIndex = [];
        this.bannerFourIndex = [];
        return;
      }
      if (width >= 1200) {
        const result = [10];
        let current = 10;
        let interval = [11];

        this.bannerFourCountAssign(
          result,
          current,
          this.$props.diamondCount,
          interval
        );
      } else if (width >= 768) {
        const result = [4];
        let current = 4;
        let interval = [5];
        this.bannerThreeCountAssign(
          result,
          current,
          this.$props.diamondCount,
          interval
        );
      } else {
        this.bannerTwoCountAssign(
          [9],
          9,
          this.$props.diamondCount,
          [10]
        );
      }
    },
    filteredBanners() {
      this.handleResize();
    },
  },
  computed: {
    getFormattedPrice() {
      // first type : $4512.63
      // return (item) => {
      //   return `$${price?.toLocaleString("en-US", {
      //     minimumFractionDigits: 2,
      //   })}`;
      // };

      // second type : A$1452.23
      // return (item) => {
      //   // Ensure price is a number and currency is defined
      //   const price = Number(price || 0);
      //   const currency = currency || 'IND'; // Default to USD if undefined

      //   return price.toLocaleString("en-US", {
      //     style: "currency",
      //     currency: currency,
      //     minimumFractionDigits: 2,
      //   });
      // };

      // third type : AUD14523.21
      return (currency, price) => {
        price = Number(price || 0).toFixed(0);
        const newPrice = `${currency}${price?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
        })}`;
        return newPrice;
      };
    },
    filteredBanners() {
      if (!this.bannerNameArray.length) return [];
      return this.bannerNameArray.filter((banner) => {
        return (
          !banner.diamond_type ||
          banner.diamond_type === "all" ||
          banner.diamond_type === this.diamondType
        );
      });
    },
  },
  mounted() {
    if (window.innerWidth < 993) {
      this.productDivClass = "pc-div-full";
    }
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    // Grab hidden input value
    const el = document.getElementById("diamond-banners");
    if (el && el.value) {
      this.bannerNameArray = JSON.parse(el.value);
    }
  },
  methods: {
    getDiamondSrc(item) {
      if (!item.diamondImage) return getShapeFallbackImage(item.shape);
      return item.diamondImage;
    },
    handleDiamondImgError(e, shape) {
      var target = e.target || e.currentTarget;
      var fallback = getShapeFallbackImage(shape);
      target.removeAttribute("srcset");
      if (target.src === shapeToImageUrl.DEFAULT) return;
      if (target.src === fallback) {
        target.src = shapeToImageUrl.DEFAULT;
      } else {
        target.src = fallback;
      }
    },
    setLabGrownPopupModal(e, id = null) {
      e.stopPropagation();
      this.isLabGrownPopupModal = id;
    },
    getbannerPath(index, column) {
      const banners = this.filteredBanners;
      if (!banners.length) return;
      if (column == "three") {
        let bannerIndex = this.bannerThreeIndex.indexOf(index);
        if (bannerIndex != -1) {
          let i = bannerIndex % banners.length;
          return banners[i];
        }
      } else if (column == "two") {
        let bannerIndex = this.bannerTwoIndex.indexOf(index);
        if (bannerIndex != -1) {
          let i = bannerIndex % banners.length;
          return banners[i];
        }
      } else {
        let bannerIndex = this.bannerFourIndex.indexOf(index);
        if (bannerIndex != -1) {
          let i = bannerIndex % banners.length;
          return banners[i];
        }
      }
    },
    bannerThreeCountAssign(results, start, end, interval) {
      const result = results;
      let current = start;

      while (current + interval[interval.length - 1] < end) {
        for (const step of interval) {
          current += step;
          result.push(current);
        }
      }
      this.bannerThreeIndex = result;
    },
    bannerFourCountAssign(result, start, end, interval) {
      const results = result;
      let current = start;

      while (current + interval[interval.length - 1] < end) {
        for (const step of interval) {
          current += step;
          results.push(current);
        }
      }
      this.bannerFourIndex = results;
    },
    bannerTwoCountAssign(result, start, end, interval) {
      const results = result;
      let current = start;

      while (current + interval[interval.length - 1] < end) {
        for (const step of interval) {
          current += step;
          results.push(current);
        }
      }
      this.bannerTwoIndex = results;
    },
    handleResize() {
      const width = window.innerWidth;
      if (this.filteredBanners.length === 0) {
        this.bannerTwoIndex = [];
        this.bannerThreeIndex = [];
        this.bannerFourIndex = [];
        return;
      }
      if (window.innerWidth < 1441 && window.innerWidth > 992) {
        this.bannerFourIndex = [];
        this.bannerTwoIndex = [];
        if (width >= 1200) {
          this.bannerThreeIndex = [];

          if (this.bannerFourIndex.length == 0) {
            const result = [10];
            let current = 10;
            let interval = [11];
            this.bannerFourCountAssign(
              result,
              current,
              this.$props.diamondCount,
              interval
            );
          }
          this.productDivClass = "";
        } else if (width >= 768) {
          if (this.bannerFourIndex.length == 0 || this.bannerTwoIndex.length == 0) {
            const result = [4];
            let current = 4;
            let interval = [5];
            this.bannerThreeCountAssign(
              result,
              current,
              this.$props.diamondCount,
              interval
            );
          }
          this.productDivClass = "pc-div-full";
        }
      } else {
        if (this.bannerTwoIndex.length == 0) {
          const result = [10];
          let current = 10;
          let interval = [11];
          this.bannerTwoCountAssign(
            result,
            current,
            this.$props.diamondCount,
            interval
          );
        }
      }
    },
    openPopup(e, text) {
      this.isTooltipVisible = text;
    },
    getPageTitle(diamondData) {
      return getDiamondTitle(diamondData);
    },
    showPage(e, diamondId) {
      if (
        e.target.tagName.toLowerCase() == "label" ||
        e.target.tagName.toLowerCase() == "path" ||
        e.target.tagName.toLowerCase() == "span" ||
        e.target.tagName.toLowerCase() == "svg" ||
        e.target.tagName.toLowerCase() == "input" ||
        e.target.classList.contains("list-item-enable-video")
      ) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      let compName =
        this.$props.diamondType == "white"
          ? "natural-diamonds"
          : this.$props.diamondType == "lab"
            ? "lab-diamonds"
            : this.$props.diamondType == "white_color"
              ? "natural-fancy-coloured-diamonds"
              : this.$props.diamondType == "lab_color"
                ? "coloured-lab-grown-diamonds"
                : this.$props.diamondType;
      this.$route.params.shape &&
        localStorage.setItem(
          "shapename",
          this.$route.params.shape.toLowerCase()
        );
      this.$router.push({
        path: `/${compName}/diamonds`,
        query: { diamondId: diamondId },
      });
      // this.$router.push({name : compName, path:'/diamonds', params:{diamondId}})
      // if (!divType) {
      //     if (e.target.closest(".tps-diamond-grid-info-block")) return
      // } else if (divType.toLowerCase() == 'wishlist' || divType.toLowerCase() == 'diamond-info' || divType.toLowerCase() == 'close-popup' || divType.toLowerCase() == 'add-to-compare') {
      //     return
      // }
    },
    getDiamondDetailPageUrl(diamondId) {
      let compName =
        this.$props.diamondType == "white"
          ? "natural-diamonds"
          : this.$props.diamondType == "lab"
            ? "lab-diamonds"
            : this.$props.diamondType == "white_color"
              ? "natural-fancy-coloured-diamonds"
              : this.$props.diamondType == "lab_color"
                ? "coloured-lab-grown-diamonds"
                : this.$props.diamondType;
      this.$route.params.shape &&
        localStorage.setItem(
          "shapename",
          this.$route.params.shape.toLowerCase()
        );
      return `/${compName}/diamonds?diamondId=${diamondId}`;
      // this.$router.push({
      //   path: `/${compName}/diamonds`,
      //   query: { diamondId: diamondId },
      // });
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};

/* filter page component */
const ChooseDiamondsComp = {
  metadataDescr: {
    "natural-diamonds":
      "Over 200,000 GIA, AGS, HRD, IGI Natural, Lab Grown and Fancy Colour Diamonds Online. Loose Diamond Listing",
    "lab-diamonds":
      "This is lab grown diamond listing page for loose lab diamond module",
    "fancy-diamonds":
      "This is fancy diamond listing page for loose fancy diamond module",
    "gemstone-diamonds":
      "This is gemstone diamond listing page for loose gemstone diamond module",
  },
  rapnetRequestDiamonds: [],
  diamondTabs: [
    {
      diamondType: "white",
      label: "Natural Diamonds",
    },
    {
      diamondType: "lab",
      label: "Lab Grown Diamonds",
    },
    // {
    //   diamondType: "white_color",
    //   label: "Natural Colour Diamonds",
    // },
    {
      diamondType: "lab_color",
      label: "Lab Grown Colour Diamonds",
    },
  ],
  sliderOptions: ["price", "carat", "depth","ratio", "table"],
  /* step slider */
  stepSliderOptions: [
    "clarityRange",
    "cutRange",
    "colorRange",
    "polishRange",
    "symmetryRange",
    "fluroscenceRange",
    "labsRange",
  ],
  /* step slider */
  regularFilters: [
    "diamondShape",
    "clarity",
    "cut",
    "color",
    "polish",
    "symmetry",
    "fluroscence",
    "labs",
    "price",
    "carat",
    "depth",
    "table",
    "certificateNumber",
    "gemstones",
    "gemstoneNature",
    "gemstoneAvailability",
    "gemstoneLengthMin",
    "gemstoneLengthMax",
    "gemstoneWidthMin",
    "gemstoneWidthMax",
    "gemstoneOrigin",
    "gemstoneTreatment",
  ],
  gemstoneSortFields: ["stone_type", "gemstone_origin"],
  resultLimit: 20,
  filtersTooltip: {
    shape: {
      title: "Diamond Shape",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    price: {
      title: "Diamond Price",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    carat: {
      title: "Diamond Carat",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    cut: {
      title: "Diamond Cut",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    clarity: {
      title: "Diamond Clarity",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    color: {
      title: "Diamond Colour",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    lab: {
      title: "Lab",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    polish: {
      title: "Diamond Polish",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    symmetry: {
      title: "Diamond Symmetry",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    fluroscence: {
      title: "Diamond Fluroscence",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    depth: {
      title: "Diamond Depth",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    ratio: {
      title: "Diamond Ratio",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
    table: {
      title: "Diamond Table",
      content:
        "Diamond prices fluctuate frequently based on supply and demand or during our limited-time sales. For specific pricing information on your diamond of interest please click on that diamond in the search results below.",
    },
  },
  components: {
    slider: VueformSlider,
    ListViewComp,
    GridViewComp,
    ListingGridTabs,
    DataNotFoundComp,
    SpinnerComp,
    ResetFormComp,
    BreadcrumbsComp,
    WishlistPopupComp,
    HeaderStepsComp,
    StickyBarComp,
    PageBannerComp,
  },
  setup(props, context) {
    const route = useRoute();
    const diamondCompareState = reactive({
      diamondsForCompare: [],
      diamonds: [],
    });
    const filterInfoTooltipState = reactive({
      filterId: "",
    });
    const gridTabState = reactive({
      currentTab: "diamond",
    });
    const currentDiamondTab = ref("white");
    provide("diamondsForCompare", diamondCompareState);
    provide("currentGridTab", gridTabState);

    function resetCompareDiamonds() {
      diamondCompareState.diamondsForCompare = [];
      diamondCompareState.diamonds = [];
    }

    function compareDiamonds(isChecked, diamondObj) {
      diamondCompareState.diamondsForCompare =
        diamondCompareState.diamondsForCompare.filter((v) => {
          return v !== "on";
        });
      if (
        diamondCompareState.diamondsForCompare.filter(
          (v) => v == diamondObj.diamondId
        ).length
      ) {
        diamondCompareState.diamondsForCompare =
          diamondCompareState.diamondsForCompare.filter((v) => {
            return v !== diamondObj.diamondId;
          });
        diamondCompareState.diamonds = diamondCompareState.diamonds.filter(
          function (diamondJson) {
            if (diamondJson.diamondId != diamondObj.diamondId) {
              return diamondJson;
            }
          }
        );
      } else {
        diamondCompareState.diamondsForCompare.push(diamondObj.diamondId);
        diamondCompareState.diamonds.push(diamondObj);
      }
      // if(diamondCompareState.diamondsForCompare.some(obj => obj === diamondObj.diamondId)){
      // } else {
      //     if(diamondCompareState.diamondsForCompare.length == 0){
      //         diamondCompareState.diamondsForCompare.push(diamondObj.diamondId)
      //     } else {

      //     }
      // }

      handleComparedDiamonds(
        "set",
        diamondCompareState.diamondsForCompare,
        diamondObj
      );
      handleDiamondData(isChecked, diamondObj);
    }
    function handleDiamondData(isChecked, diamondObj) {
      /* if (isChecked) {
                diamondCompareState.diamonds.push(diamondObj)
            } else {
                diamondCompareState.diamonds = diamondCompareState.diamonds.filter(function (diamondJson) {
                    if (diamondJson.diamondId != diamondObj.diamondId) {
                        return diamondJson
                    }
                })
            } */

      if (diamondCompareState.diamonds.length < 1) {
        sessionStorage.removeItem(`${currentDiamondTab.value}CompareDiamonds`);
      } else {
        sessionStorage.setItem(
          `${currentDiamondTab.value}CompareDiamonds`,
          JSON.stringify(diamondCompareState.diamonds)
        );
      }
    }
    function handleComparedDiamonds(action, diamonds = [], obj) {
      if (action === "set") {
        if (diamonds.length < 1) {
          sessionStorage.removeItem(
            `${currentDiamondTab.value}ComparedDiamondList`
          );
        } else {
          /* if(diamonds.length){
                        sessionStorage.setItem(`${currentDiamondTab.value}ComparedDiamondList`, diamonds)
                    } else {
                        let array = [];
                        if(sessionStorage.getItem(`${currentDiamondTab.value}ComparedDiamondList`)!==null){
                            array = JSON.parse(sessionStorage.getItem(`${currentDiamondTab.value}ComparedDiamondList`))
                        }
                        array.push(obj.diamondId)
                        sessionStorage.setItem(`${currentDiamondTab.value}ComparedDiamondList`,array)
                    } */
          sessionStorage.setItem(
            `${currentDiamondTab.value}ComparedDiamondList`,
            diamonds
          );
        }
      } else {
        if (
          sessionStorage.getItem(
            `${currentDiamondTab.value}ComparedDiamondList`
          ) != null
        ) {
          return sessionStorage
            .getItem(`${currentDiamondTab.value}ComparedDiamondList`)
            .split(",");
        } else {
          return null;
        }
      }
    }
    function openFilterInfoTooltip(e, filterId) {
      filterInfoTooltipState.filterId = filterId;
    }
    function changeGridTab(tab) {
      gridTabState.currentTab = tab;
    }

    function injectCompareDiamondData() {
      if (
        handleComparedDiamonds("get") != null &&
        sessionStorage.getItem(`${currentDiamondTab.value}CompareDiamonds`) !=
        null
      ) {
        diamondCompareState.diamondsForCompare = handleComparedDiamonds("get");
        diamondCompareState.diamonds = getConvertedComparedDiamonds(
          JSON.parse(
            sessionStorage.getItem(`${currentDiamondTab.value}CompareDiamonds`)
          )
        );
      }
    }

    /* return currency wise price converted compared diamonds */
    function getConvertedComparedDiamonds(comparedDiamonds = []) {
      var convertedDiamonds = [];
      comparedDiamonds.forEach((comparedDiamond) => {
        comparedDiamond = getCurrencyWiseDiamond(comparedDiamond);
        convertedDiamonds.push(comparedDiamond);
      });
      return convertedDiamonds;
    }

    watch(
      () => route.params.diamondType,
      (diamondType) => {
        if (diamondType != undefined) {
          var urlParam = diamondType.split("-")[0];
          var urlParam1 = diamondType.split("-")[1];
          var diamondTab =
            urlParam.toLowerCase() == "natural" &&
              urlParam1.toLowerCase() == "color"
              ? "white_color"
              : urlParam.toLowerCase() == "lab" &&
                urlParam1.toLowerCase() == "color"
                ? "lab_color"
                : urlParam.toLowerCase() == "natural"
                  ? "white"
                  : urlParam.toLowerCase() == "lab"
                    ? "lab"
                    : urlParam.toLowerCase();
          currentDiamondTab.value = diamondTab;
          resetCompareDiamonds();
          injectCompareDiamondData();
          changeGridTab("diamond");
        }
      },
      { immediate: true }
    );

    return {
      openFilterInfoTooltip,
      compareDiamonds,
      changeGridTab,
      ...toRefs(diamondCompareState),
      ...toRefs(gridTabState),
      ...toRefs(filterInfoTooltipState),
    };
  },
  data() {
    return {
      isMobileView: window.innerWidth <= 615,
      isTooltipVisible: "",
      tabTitle: "Choose Diamonds",
      gridTabLabel: "Diamond Found",
      request: null,
      diamondCount: 0,
      loading: false,
      dataNotFound: false,
      sendRequest: true,
      page: 1,
      items: [],
      slideDown: false,
      toggleClass: "",
      bannerClass: "pc-show-banner",
      showAdvancedSearch: false,
      showResetFilters: false,
      showCertError: false,
      openFilterSection: false,
      showTooltip: false,
      hideFilterTooltip: true,
      tooltipText: "",
      tooltipClass: "",
      breadcrumbs: [],
      timeOutId: "",
      hideCompareDiamondsTab: true,
      hideResultViewSwitch: false,
      showWishlistPopup: false,
      WishlistPopupContent: "",
      wishlistItemName: "",
      isComponentMounted: 0,
      recentDiamondsCount: 0,
      recentDiamonds: [],
      showCutFilterSection: true,
      /* step slider */
      displayStepSlider: true,
      /* step slider */
      disableFilter: false,
      certSearchTimer: null,
      caratFaqsOpen: [false, false, false],
      faqsNatural: [
        {
          question: "What is a natural diamond?",
          answer:
            "A natural diamond is a stone formed deep within the earth over billions of years under extreme heat and pressure. It is mined, not grown in a laboratory. Natural diamonds are graded independently by organisations such as the GIA or IGI for cut, colour, clarity, and carat weight.",
          open: false,
        },
        {
          question: "What is the difference between a natural diamond and a lab-grown diamond?",
          answer:
            "Natural diamonds are mined from the earth and formed over billions of years. Lab-grown diamonds are created in a laboratory in weeks. Both are physically and chemically identical - the difference is origin, rarity, and price. Natural diamonds carry geological rarity that lab-grown stones do not.",
          open: false,
        },
        {
          question: "Are your natural diamonds GIA or IGI certified?",
          answer:
            "Yes, every natural diamond in our collection is certified by the GIA (Gemological Institute of America) or IGI (International Gemological Institute). Certification provides an independent grade for cut, colour, clarity, and carat weight, so you know exactly what you are purchasing.",
          open: false,
        },
        {
          question: "Which natural diamond shape is most popular in Australia?",
          answer:
            "Oval is currently the most popular natural diamond shape in Australia, followed by round brilliant and marquise. Oval natural diamonds face up larger than their carat weight suggests, which makes them particularly sought after in 1ct to 3ct sizes for engagement rings.",
          open: false,
        },
        {
          question: "How much does a natural diamond ring cost in Australia?",
          answer:
            "Natural diamond ring prices in Australia vary depending on carat weight, shape, cut quality, and certification grade. At Rings of Australia, our natural diamond rings are priced well below high-street rates because we operate directly from our Brisbane studio without retail markup.",
          open: false,
        },
        {
          question: "What is the difference between a 1ct and a 3ct natural diamond?",
          answer:
            "A 3-carat natural diamond is significantly larger and rarer than a 1ct stone. Carat refers to weight, not diameter, so the visual difference depends on the shape - oval and marquise cuts spread wider relative to their weight than round or princess cuts. Cut quality matters more as carat size increases.",
          open: false,
        },
        {
          question:
            "Can I design a custom natural diamond ring?",
          answer:
            "Yes, our Brisbane studio handcrafts custom natural diamond rings from the ground up. You choose the diamond shape, carat weight, setting style, and metal type. We provide 3D renders before production begins, and most custom rings are completed within 3 to 6 weeks.",
          open: false,
        },
        {
          question:
            "Do you offer natural diamond rings that are not lab-grown?",
          answer:
            "Yes, every ring in this collection features a mined, earth-formed natural diamond, not a lab-grown stone. All natural diamonds are conflict-free and certified by the GIA or IGI. If you are specifically looking for mined diamonds, every product on this page qualifies.",
          open: false,
        },
      ],
      faqsColorNatural: [
        {
          question: "Are natural coloured diamonds rare?",
          answer:
            "Yes. Natural pink diamonds, yellow diamonds, and green diamonds are some of the rarest gemstones in the world. Their unique colours occur due to natural processes during diamond formation, making each stone truly one of a kind.",
          open: false,
        },
        {
          question: "How are natural pink and yellow diamonds certified?",
          answer:
            "All of our natural coloured diamonds come with GIA or IGI certification, ensuring authenticity, quality, and accurate grading of colour, cut, clarity, and carat.",
          open: false,
        },
        {
          question:
            "Are coloured diamond rings suitable for engagement and wedding rings?",
          answer:
            "Absolutely. Natural pink diamonds and yellow diamond engagement rings are a popular choice for couples looking for something extraordinary. Their durability makes them perfect for daily wear.",
          open: false,
        },
        {
          question:
            "Are natural coloured diamonds more valuable than white diamonds?",
          answer:
            "Yes. Because of their rarity, natural coloured diamonds often command a higher value than traditional white diamonds, making them both a stunning choice and a long-term investment.",
          open: false,
        },
      ],
      faqsLab: [
        {
          question: "Are lab grown diamonds real diamonds?",
          answer:
            "Yes, Lab grown diamonds are physically, chemically, and optically identical to mined diamonds. They have the same hardness, refractive index, and brilliance. The only difference is origin - a lab grown diamond is created in a controlled environment rather than extracted from the earth.",
          open: false,
        },
        {
          question:
            "What is the difference between a lab grown diamond and a natural diamond?",
          answer:
            "Lab grown diamonds are created in weeks in a laboratory. Natural diamonds form over billions of years beneath the Earth. Both are chemically identical - the differences are origin, geological rarity, and price. Lab grown diamonds are priced significantly below mined equivalents at the same carat weight and quality grade.",
          open: false,
        },
        {
          question:
            "Are your lab grown diamonds IGI certified?",
          answer:
            "Yes, every lab-grown diamond in our collection is IGI (International Gemological Institute) certified. The certificate independently grades the stone for cut, colour, clarity, and carat weight. IGI is the leading certification body for lab grown diamonds worldwide.",
          open: false,
        },
        {
          question:
            "How much does a 1 carat lab grown diamond ring cost in Australia?",
          answer:
            "A 1 carat lab grown diamond ring is priced significantly below a mined equivalent at the same quality grade. At Rings of Australia, our lab grown diamond rings are handcrafted in Brisbane and priced well below high-street rates, without any compromise on certification or craftsmanship quality.",
          open: false,
        },
        {
          question:
            "Which lab grown diamond shape is most popular?",
          answer:
            "Oval is currently the most searched lab grown diamond shape in Australia, followed by radiant cut and round brilliant. Oval lab grown diamonds face up larger than their carat weight suggests, which makes them a strong choice at every carat size. Radiant cut lab grown diamonds are the fastest-growing shape in our collection.",
          open: false,
        },
        {
          question: "What carat sizes do you carry in lab grown diamonds?",
          answer:
            "We carry lab grown diamonds from 0.5ct through to 5ct and above across all major shapes. The most commonly purchased weights are 1ct, 1.5ct, and 2ct. Larger carat weights, 3ct and 3.5ct, are significantly more accessible in lab grown diamonds than in mined equivalents.",
          open: false,
        },
        {
          question: "Can I design a custom lab grown diamond ring?",
          answer:
            "Yes, custom lab-grown diamond rings are one of our core services at Rings of Australia. You choose the diamond shape, carat weight, setting style, and metal. We produce 3D renders before any metal is cut, and most custom rings are completed within 3 to 6 weeks.",
          open: false,
        },
        {
          question: "Will people know my diamond is lab grown?",
          answer:
            "No, not from looking at it. Lab grown diamonds are visually identical to mined diamonds. Even trained gemologists require specialised laboratory equipment to distinguish between the two. The only way someone will know is if you choose to tell them.",
          open: false,
        },
      ],
      faqsColorLab: [
        {
          question: "Can you get coloured lab grown diamonds?",
          answer:
            "Yes, lab-grown coloured diamonds are available in yellow, green, blue, pink, orange, red, purple, and grey. The colour in a diamond, whether mined or lab-grown, comes from specific elements or structural conditions within the crystal. Lab grown technology replicates these precisely, producing the same colour range as natural coloured diamonds.",
          open: false,
        },
        {
          question: "Are coloured lab grown diamonds real diamonds?",
          answer:
            "Yes, lab-grown coloured diamonds are physically, chemically, and optically identical to mined coloured diamonds. They have the same crystal structure, the same refractive index, and the same hardness. The only difference is origin - a lab grown coloured diamond is created in a controlled environment rather than formed beneath the earth over millions of years.",
          open: false,
        },
        {
          question: "What causes colour in lab grown diamonds?",
          answer:
            "Different elements and structural conditions create different colours. Nitrogen produces yellow and orange tones. Boron creates blue. Radiation exposure during or after growth creates green. Pink and red colours come from structural distortions in the crystal lattice. Lab grown diamonds replicate these conditions deliberately to produce consistent, vivid colour across each stone.",
          open: false,
        },
        {
          question: "What is a lab grown yellow diamond?",
          answer:
            "A lab grown yellow diamond is a genuine diamond that gets its yellow colour from nitrogen particles within the crystal structure - the same mechanism as in natural yellow diamonds. Lab grown yellow diamonds are available from light canary through to deep vivid yellow and are priced significantly below natural yellow diamonds at the same colour intensity and carat weight.",
          open: false,
        },
        {
          question: "What is a lab grown green diamond?",
          answer:
            "A lab grown green diamond replicates the colour that occurs in natural green diamonds through radiation exposure during crystal formation. Natural green diamonds are among the rarest coloured diamonds in the world. Lab grown green diamonds deliver the same vivid green colour at a fraction of the mined equivalent price, making them accessible for engagement rings and custom jewellery designs.",
          open: false,
        },
        {
          question: "Are lab grown coloured diamonds more expensive than white lab grown diamonds?",
          answer:
            "Yes, typically. Coloured lab grown diamonds require additional steps during the growth process to introduce or replicate the colouring elements. However, they remain priced significantly below natural coloured diamonds of the same colour grade and carat weight - often up to 70% less. The price difference versus natural coloured diamonds is where lab grown coloured stones deliver the most significant value.",
          open: false,
        },
        {
          question: "Can I get a custom coloured diamond engagement ring?",
          answer:
            "Yes, Every coloured lab grown diamond piece at Rings of Australia is built to order. You choose the diamond colour, shape, carat weight, setting style, and metal type. Our Brisbane studio handles the full design process, including 3D renders shared before production begins. Most custom coloured diamond rings are completed within 3 to 6 weeks.",
          open: false,
        },
        {
          question: "Which shape is best for a coloured lab grown diamond?",
          answer:
            "Oval and cushion cuts are generally considered the best shapes for coloured diamonds because their facet patterns enhance colour saturation and warmth. Radiant cut is also a strong choice for vivid colours such as yellow and blue. Round brilliant cuts tend to reflect more white light, which can dilute colour intensity, though they remain a popular choice for lighter colour grades.",
          open: false,
        },
      ],
      filters: {
        initialFilters: {
          selectedDiamondTab: window.location.pathname.includes("/lab-diamonds")
            ? "lab"
            : window.location.pathname.includes("/coloured-lab-grown-diamonds")
              ? "lab_color"
              : window.location.pathname.includes("/natural-fancy-coloured-diamonds")
                ? "white_color"
                : window.location.pathname.includes("/natural-diamonds")
                  ? "white"
                  : "",
          showAppliedFiltersSection: false,
          certificateNumber: "",
          isListView: false,
          gemstones: [],
          gemstoneNature: [],
          gemstoneAvailability: [],
          gemstoneLengthMin: 0,
          gemstoneLengthMax: 100,
          gemstoneWidthMin: 0,
          gemstoneWidthMax: 100,
          gemstoneOrigin: "Other",
          gemstoneTreatment: [],
          diamondShape: [],
          fancyColor: [],
          clarity: [],
          cut: [],
          color: [],
          polish: [],
          symmetry: [],
          fluroscence: [],
          labs: [],
          // wishlistItems: document.getElementById("pc-vue-ringbuilder-ti-wishlist-diamond-ids").value.split(","),
          sortby: {
            type: "final_price",
            dir: "ASC",
          },
          price: {
            value: [0, 100000],
          },
          priceTxtFields: {
            minPrice: "0",
            maxPrice: "100000",
          },
          carat: {
            value: [1, 10],
          },
          depth: {
            value: [45, 90],
          },
          ratio: {
            value: [0,2.75],
          },
          table: {
            value: [45, 90],
          },
          /* step sliders */
          clarityRange: {
            value: [0, 8],
          },
          cutRange: {
            value: [0, 4],
          },
          colorRange: {
            value: [0, 8],
          },
          polishRange: {
            value: [0, 5],
          },
          symmetryRange: {
            value: [0, 5],
          },
          fluroscenceRange: {
            value: [0, 5],
          },
          labsRange: {
            value: [0, 4],
          },
          /* step sliders */
          sortColumnsWidth: "14.28",
          sortFields: {
            stone_type: {
              lable: "Gemstone",
              dir: "ASC",
              dataField: "stoneType",
              showField: true,
              isAdvance: false,
            },
            shape: {
              lable: "Shape",
              dir: "ASC",
              dataField: "shape",
              showField: true,
              isAdvance: false,
            },
            carat_weight: {
              lable: "Carat",
              dir: "ASC",
              dataField: "caratWeight",
              showField: true,
              isAdvance: false,
            },
            color: {
              lable: "Colour",
              dir: "ASC",
              dataField: "color",
              showField: true,
              isAdvance: false,
            },
            clarity: {
              lable: "Clarity",
              dir: "ASC",
              dataField: "clarity",
              showField: true,
              isAdvance: false,
            },
            cut: {
              lable: "Cut",
              dir: "ASC",
              dataField: "cut",
              showField: true,
              isAdvance: false,
            },
            lab: {
              lable: "Lab",
              dir: "ASC",
              dataField: "lab",
              showField: true,
              isAdvance: false,
            },
            final_price: {
              lable: "Price",
              dir: "ASC",
              dataField: "finalPrice",
              showField: true,
              isAdvance: false,
            },
            gemstone_origin: {
              lable: "Origin",
              dir: "ASC",
              dataField: "location",
              showField: true,
              isAdvance: false,
            },
            table_perc: {
              lable: "Table(%)",
              dir: "ASC",
              dataField: "tablePerc",
              showField: false,
              isAdvance: true,
            },
            dept_perc: {
              lable: "Depth(%)",
              dir: "ASC",
              dataField: "deptPerc",
              showField: false,
              isAdvance: true,
            },
            polish: {
              lable: "Polish",
              dir: "ASC",
              dataField: "polish",
              showField: false,
              isAdvance: true,
            },
            symmetry: {
              lable: "Sym.",
              dir: "ASC",
              dataField: "symmetry",
              showField: false,
              isAdvance: true,
            },
            flour_intensity: {
              lable: "Flour.",
              dir: "ASC",
              dataField: "flourIntensity",
              showField: false,
              isAdvance: true,
            },
          },
        },
        price: {
          symbol: currencySymbol,
          min: 0,
          max: 100000,
          step: 1,
        },
        carat: {
          symbol: "ct.",
          min: 0.5,
          max: 10,
          step: -1,
        },
        depth: {
          symbol: "%",
          min: 45,
          max: 90,
          step: -1,
        },
        ratio: {
          symbol: "",
          min: 0,
          max: 2.75,
          step: -1,
        },
        table: {
          symbol: "%",
          min: 45,
          max: 90,
          step: -1,
        },
        /* step slider */
        clarityRange: {
          min: 0,
          max: 7,
          step: 1,
        },
        cutRange: {
          min: 0,
          max: 4,
          step: 1,
        },
        colorRange: {
          min: 0,
          max: 8,
          step: 1,
        },
        polishRange: {
          min: 0,
          max: 3,
          step: 1,
        },
        symmetryRange: {
          min: 0,
          max: 3,
          step: 1,
        },
        fluroscenceRange: {
          min: 0,
          max: 4,
          step: 1,
        },
        labsRange: {
          min: 0,
          max: 4,
          step: 1,
        },
        /* step slider */
        gemstoneDefaultLengthMin: 0,
        gemstoneDefaultLengthMax: 100,
        gemstoneDefaultWidthMin: 0,
        gemstoneDefaultWidthMax: 100,
      },
      settingCanBeSetWithShapes: [],
      stepData: (function() {
        var fp = sessionStorage.getItem("firstPage");
        if (fp == "settingPage") {
          return { firstStep: { headerTitle: "SETTING" }, secondStep: { headerTitle: "DIAMOND" }, thirdStep: { headerTitle: "Ring" } };
        }
        return { firstStep: { headerTitle: "DIAMOND" }, secondStep: { headerTitle: "SETTING" }, thirdStep: { headerTitle: "Ring" } };
      })(),
      totalSteps: 1,
      pageStickyItems: [],
      showBannerTitle: true,
      bannerTitle: "Select Your Diamond",
      recentDiamondId: "",
      priceRangeArr: [],
      defaultMinPrice: parseInt(diamondMinPrice),
      defaultMaxPrice: parseInt(diamondMaxPrice),
      compareDiamondArray: [],
      windowInnerwidth: "1024px",
      redirectPage: "",
      isLoadMoreBtnActive: false,
      setting: "",
      firstDiamondText: "Choose the First Diamond",
    };
  },
  delimiters: ["[[", "]]"],
  template: "#filter-page",
  computed: {
    /* gemstone filter options */
    getGemstones() {
      return [
        "Sapphire",
        "Emerald",
        "Ruby",
        "Morganite",
        "Tanzanite",
        "Garnet",
        "Alexandrite",
        "Topaz",
        "Opal",
        "Aquamarine",
        "Citrine",
        "Amethyst",
        "Ametrine",
        "Spinel",
        "Tourmaline",
        "Peridot",
        "Zircon",
        "Pearl",
      ];
    },
    getGemstoneNature() {
      return ["Natural", "Lab Grown"];
    },
    getGemstoneAvailability() {
      return ["Virtual", "In House", "Image Available", "Guaranteed Available"];
    },
    getGemstoneOrigin() {
      return ["Burma", "Madagascar", "Ceylon", "Other"];
    },
    getGemstoneTreatment() {
      return ["Natural Unheated", "Heated", "Other"];
    },
    /* gemstone filter options */
    getDiamondShapes() {
      return [
        "Round",
        "Oval",
        "Cushion",
        "Emerald",
        "Princess",
        "Radiant",
        "Pear",
        "Marquise",
        "Asscher",
        "Heart",
      ];
    },
    getDiamondFancyColors() {
      return ["Yellow", "Pink", "Blue", "Red", "Green", "Champagne"];
    },
    getClarity() {
      return ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1"];
    },
    getCut() {
      return ["Good", "Very Good", "Excellent", "Ideal"].reverse();
    },
    getColor() {
      return ["D", "E", "F", "G", "H", "I", "J", "K"];
    },
    getFancyColor() {
      return [
        "Blue",
        "Peach",
        "Pink",
        "Yellow",
        "Green",
        "Purple",
        "Red",
        "Champagne",
        "Orange",
        "White",
        "Black",
        "Grey",
        "Colorless",
        "Other",
      ];
    },
    getPolish() {
      return ["Excellent", "Very Good", "Good"];
    },
    getSymmetry() {
      return ["Excellent", "Very Good", "Good"];
    },
    getFluroscence() {
      return ["None", "Faint", "Medium", "Strong"];
    },
    getSortByType() {
      return [
        {
          label: "Price",
          value: "price",
        },
        {
          label: "Carat",
          value: "Size",
        },
        {
          label: "Colour",
          value: "color",
        },
        {
          label: "Clarity",
          value: "clarity",
        },
        {
          label: "Cut",
          value: "cut",
        },
      ];
    },
    getSortByDir() {
      return [
        {
          label: "Low To High",
          value: "ASC",
        },
        {
          label: "High To Low",
          value: "DESC",
        },
      ];
    },
    getLabs() {
      if (
        this.filters.initialFilters.selectedDiamondTab == "lab" ||
        this.filters.initialFilters.selectedDiamondTab == "lab_color"
      ) {
        return ["GIA", "IGI"];
      } else {
        return ["GIA", "IGI", "AGS"];
      }
    },
    showGemstoneDimensionsAppliedFilterSection() {
      var appliedLengthMin = this.filters.initialFilters.gemstoneLengthMin;
      var appliedLengthMax = this.filters.initialFilters.gemstoneLengthMax;
      var appliedWidthMin = this.filters.initialFilters.gemstoneWidthMin;
      var appliedWidthMax = this.filters.initialFilters.gemstoneWidthMax;

      var defaultLengthMin = this.filters.gemstoneDefaultLengthMin;
      var defaultLengthMax = this.filters.gemstoneDefaultLengthMax;
      var defaultWidthMin = this.filters.gemstoneDefaultWidthMin;
      var defaultWidthMax = this.filters.gemstoneDefaultWidthMax;

      if (
        appliedLengthMin != defaultLengthMin ||
        appliedLengthMax != defaultLengthMax ||
        appliedWidthMin != defaultWidthMin ||
        appliedWidthMax != defaultWidthMax
      ) {
        return true;
      } else {
        return false;
      }
    },
    getGemstoneDimensionText() {
      var appliedLengthMin = this.filters.initialFilters.gemstoneLengthMin;
      var appliedLengthMax = this.filters.initialFilters.gemstoneLengthMax;
      var appliedWidthMin = this.filters.initialFilters.gemstoneWidthMin;
      var appliedWidthMax = this.filters.initialFilters.gemstoneWidthMax;
      return `${appliedLengthMin}-${appliedLengthMax} * ${appliedWidthMin}-${appliedWidthMax} mm`;
    },
    getCertificateFieldLabel() {
      return (diamondType) => {
        return diamondType == "gemstone"
          ? "Search By Gemstone Or Certificate Number"
          : "Search By Report Number";
      };
    },
    /* step slider */
    getStepSliderStepTicks() {
      return (filterOptions) => {
        var sliderStepTickPercArr = [];
        var sliderStepTickPerc = 0;
        var totalSliderWidth = 100;
        var totalFilterOptions = filterOptions.length;
        var stepPercentage = totalSliderWidth / totalFilterOptions;
        for (var tickCount = 1; tickCount < totalFilterOptions; tickCount++) {
          sliderStepTickPerc += stepPercentage;
          sliderStepTickPercArr.push(sliderStepTickPerc);
        }
        return sliderStepTickPercArr;
      };
    },
    /* step slider */
    getStepSliderAppliedFilterTxt() {
      return (filterType) => {
        var appliedFilterOptions = this.filters.initialFilters[filterType];
        if (appliedFilterOptions.length == 1) {
          return appliedFilterOptions[0];
        } else {
          return `${appliedFilterOptions[0]} - ${appliedFilterOptions[appliedFilterOptions.length - 1]
            }`;
        }
      };
    },
    /* step slider */
  },
  mounted() {
    // Note: sold-out cleanup (dropping the stale diamond selection/step data) now happens
    // surgically at detection time in clearBuilderSelection() (diamond-availability.js),
    // which preserves a still-valid Setting entry. Do NOT also wipe stepData/selectedDiamond
    // here — this used to run after that surgical cache was already written and would nuke
    // it wholesale, so the page looked fine on the SPA redirect (in-memory state was already
    // correct) but lost the Setting entirely on the next manual refresh.
    window.addEventListener('resize', this.handleResize);
    document.addEventListener("resize", this.windowResizing());
    if (!!sessionStorage.getItem("redirection")) {
      this.redirectPage = sessionStorage
        .getItem("redirection")
        .includes("-diamonds")
        ? "DIAMOND"
        : "SETTING";
    }
    // element?.addEventListener('scroll', this.handleScroll);
    if (
      !!sessionStorage.getItem(
        `${this.filters.initialFilters.selectedDiamondTab}CompareDiamonds`
      )
    ) {
      this.compareDiamondArray = JSON.parse(
        sessionStorage.getItem(
          `${this.filters.initialFilters.selectedDiamondTab}CompareDiamonds`
        )
      );
    }
    /* if(!!sessionStorage.getItem(`${this.filters.initialFilters.selectedDiamondTab}CompareDiamonds`)){
            this.compareDiamondArrays = JSON.parse(sessionStorage.getItem(`${this.filters.initialFilters.selectedDiamondTab}CompareDiamonds`))
        } */
    if (localStorage.getItem("shapename")) {
      localStorage.removeItem("shapename");
    }
    const saved = sessionStorage.getItem("selectedSetting");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        this.setting = parsed;
      } catch (e) {
        console.error("Session setting parse error:", e);
      }
    }

    const selectedFirstDiamond = sessionStorage.getItem("selectedDiamond");
    if (selectedFirstDiamond) {
      this.firstDiamondText = "Choose The Second Diamond";
    }

    /* if (this.$route.params.shape && this.$route.params.shape?.toLowerCase() !== 'diamonds') {
            var shapename = `${this.$route.params.shape.slice(0, 1).toUpperCase()}${this.$route.params.shape.slice(1)}`
            this.filters.initialFilters.diamondShape = shapename
        } */
    this.isComponentMounted = 1;
    // if(this.filters.initialFilters.selectedDiamondTab == 'lab'){
    //     this.filters.initialFilters.clarityRange.value= [0,8]
    //     this.filters.clarityRange.max = 8
    // } else if(this.filters.initialFilters.selectedDiamondTab == 'white'){
    //     this.filters.clarityRange.max = 7
    //     this.filters.initialFilters.clarityRange.value= [0,7]
    // }
    if (window.innerWidth <= 767) {
      this.filters.initialFilters.isListView = false;
      this.hideResultViewSwitch = true;
    }

    this.handleBannerTitle();
    handlePageBodyClass("add", "pc-ringbuilder-diamond-listing-page");
    document.addEventListener("click", () => (this.isTooltipVisible = ""));

    const selectedDiamond = JSON.parse(
      sessionStorage.getItem("selectedDiamond")
    );
    const isSecondDiamondSearching = sessionStorage.getItem(
      "searchingSecondDiamond"
    );

    let type =
      this.$props.diamondType == "white"
        ? "natural-diamonds"
        : this.$props.diamondType == "lab"
          ? "lab-diamonds"
          : this.$props.diamondType == "white_color"
            ? "natural-fancy-coloured-diamonds"
            : this.$props.diamondType == "lab_color"
              ? "coloured-lab-grown-diamonds"
              : this.$props.diamondType;

    if (!!selectedDiamond && isSecondDiamondSearching) {
      if (type != selectedDiamond?.diamondType) {
        let diamondType =
          selectedDiamond?.diamondType == "white"
            ? "natural"
            : selectedDiamond?.diamondType == "lab"
              ? "lab"
              : selectedDiamond?.diamondType == "white_color"
                ? "natural-color"
                : selectedDiamond?.diamondType == "lab_color"
                  ? "coloured-lab-grown"
                  : selectedDiamond?.diamondType; // not disabled
        this.$router.replace({
          path: `collections/${diamondType}-diamonds`,
        });
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.certSearchTimer);
    this.isComponentMounted = 0;
    handlePageBodyClass("remove", "pc-ringbuilder-diamond-listing-page");
    document.removeEventListener("click", () => (this.isTooltipVisible = ""));
  },
  watch: {
    "$route.params.diamondType": {
      handler(diamondType) {
        if (diamondType != undefined) {
          var _isTabSwitch = this.isComponentMounted == 1;
          var _savedMinPrice = this.filters.initialFilters.priceTxtFields.minPrice;
          var _savedMaxPrice = this.filters.initialFilters.priceTxtFields.maxPrice;
          if (_isTabSwitch) {
            sessionStorage.setItem("storedMinPrice", _savedMinPrice);
            sessionStorage.setItem("storedMaxPrice", _savedMaxPrice);
          }
          this.setPageMetaData();
          this.page = 1;
          this.items = [];
          this.initDiamondGridScroll();
          this.setRangePricesInArray();
          this.handleMetaData(diamondType);
          this.handleBreadcrumbs(diamondType);
          // if (!this.$route?.params?.shape) {
          //   this.changeRouterShape("round");
          // }
          this.injectCurrentDiamondType(diamondType);
          this.handleGridTabLabel();
          this.handleSortFields();
          this.initializeAllFilters(1);
          if (_isTabSwitch) {
            this.filters.initialFilters.priceTxtFields.minPrice = _savedMinPrice;
            this.filters.initialFilters.priceTxtFields.maxPrice = _savedMaxPrice;
            this.$nextTick(() => {
              this.filters.initialFilters.priceTxtFields.minPrice = _savedMinPrice;
              this.filters.initialFilters.priceTxtFields.maxPrice = _savedMaxPrice;
              sessionStorage.removeItem("storedMinPrice");
              sessionStorage.removeItem("storedMaxPrice");
            });
          }
          this.initStepSliders();
          this.injectAppliedFilters();
          this.handleStepData();
          this.updateDiamondShape();
          this.handleStickyBarItems();
          this.handleSelectedSettingShapes();
          this.shouldShowAppliedFilters();
          this.handleCutFilter();
          this.handleRecentlyViewedDiamonds();
          sessionStorage.setItem(
            `${this.filters.initialFilters.selectedDiamondTab}CurrentPage`,
            "1"
          );
          this.loadCachedData();
        }
      },
      immediate: true,
    },
    "$route.params.shape": {
      handler(shape) {
        if (shape != undefined) {
          this.handleBreadcrumbsShape(shape);
          this.setPageMetaData();
        }
      },
      immediate: true,
    },
    "filters.initialFilters.diamondShape": {
      // The selected shape is part of the breadcrumb label, and picking one from
      // the filter doesn't always change the route (nor does clearing it).
      handler() {
        if (this.$route.params.diamondType) {
          this.handleBreadcrumbs(this.$route.params.diamondType);
        }
      },
      deep: true,
    },
    "$route.query.maxPrice": {
      handler(maxPrice) {
        if (maxPrice) {
          this.setSliderValues(null, "price", "max", maxPrice)
          this.$router.replace({ query: { ...this.$route.query, maxPrice: undefined } });
        }
      },
      immediate: true,
      deep: true
    },
    "filters.initialFilters.price": {
      handler(newPriceIndexArr) {
        this.handlePriceFields(true);
      },
      deep: true,
    },
    diamondCount: {
      handler() {
        if (
          parseInt(this.diamondCount) - this.items.length > 0 &&
          this.items.length <= 20
        ) {
          this.isLoadMoreBtnActive = true;
        } else {
          this.isLoadMoreBtnActive = false;
        }
      },
      deep: true,
    },
  },
  updated() {
    this.windowResizing();
  },
  methods: {
    handleResize() {
      this.isMobileView = window.innerWidth <= 615;
    },
    isSecondDiamondSearching(type) {
      const selectedDiamond = JSON.parse(
        sessionStorage.getItem("selectedDiamond")
      );
      const isSecondDiamondSearching = sessionStorage.getItem(
        "searchingSecondDiamond"
      );

      if (!!selectedDiamond && isSecondDiamondSearching) {
        if (type === selectedDiamond?.diamondType) {
          return false; // not disabled
        } else {
          return true; // disabled
        }
      } else {
        return false; // default not disabled
      }
    },
    setPageMetaData() {
      // Get the current URL and extract the slug
      const currentUrl = window.location.href;
      const urlParts = currentUrl.split("/");
      const shape = this.$route?.params?.shape; // e.g., 'round' from '/collections/natural/round'
      let diamondType =
        this.$route.params.diamondType == "natural-diamonds"
          ? "natural" : this.$route.params.diamondType == "natural-fancy-coloured-diamonds"
            ? "natural_color"
            : this.$route.params.diamondType == "lab-diamonds"
              ? "lab"
              : this.$route.params.diamondType == "coloured-lab-grown-diamonds"
                ? "lab_color"
                : "lab";

      // Check if the collection name is "Engagement Rings" (approximated from URL)
      const collectionPath = urlParts[urlParts.length - 1]; // e.g., 'engagement-rings'
      // Access Shopify section settings (rendered via Liquid or ShopifyConfig)
      const sectionSettings =
        window.ShopifyConfig.diamondsMetaData[diamondType] || {};

      // Construct the meta key based on the shape (e.g., 'pave_meta_title')
      const metaTitleKey = `${shape}_${diamondType}_meta_title`;
      const metaDescriptionKey = `${shape}_${diamondType}_meta_description`;

      // Get meta data from settings
      const metaTitle = sectionSettings[metaTitleKey];
      const metaDescription = sectionSettings[metaDescriptionKey];

      // Only update if meta data is found (not undefined or empty)
      if (metaTitle && metaDescription) {
        // Update page title and meta tags
        this.pageTitle = metaTitle;
        this.pageDescription = metaDescription;
        document.title = metaTitle;

        // Update or create meta tags
        let metaTitleTag = document.querySelector('head meta[name="title"]');
        if (!metaTitleTag) {
          metaTitleTag = document.createElement("meta");
          metaTitleTag.setAttribute("name", "title");
          document.head.appendChild(metaTitleTag);
        }
        metaTitleTag.setAttribute("content", metaTitle);

        let metaDescriptionTag = document.querySelector(
          'head meta[name="description"]'
        );
        if (!metaDescriptionTag) {
          metaDescriptionTag = document.createElement("meta");
          metaDescriptionTag.setAttribute("name", "description");
          document.head.appendChild(metaDescriptionTag);
        }
        metaDescriptionTag.setAttribute("content", metaDescription);
      }
    },
    openFilterDivSection(bool = undefined) {
      let klaviyoSendMessageDiv = document.querySelector(
        ".needsclick.kl-teaser-SeKnfZ.kl-private-reset-css-Xuajs1"
      );
      if (!!klaviyoSendMessageDiv) {
        klaviyoSendMessageDiv.style.zIndex = !!bool ? "0" : "90000";
      }
    },
    changeRouterShape(shape) {
      this.handleBreadcrumbsShape(shape);
      this.$router.push({
        path: `/${this.$route.params.diamondType}/${shape.toLowerCase()}`,
      });
    },
    updateDiamondShape() {
      if (
        this.$route.params.shape &&
        this.$route.params.shape?.toLowerCase() !== "diamonds" &&
        this.isValidShape(this.$route.params.shape)
      ) {
        var shapename = `${this.$route.params.shape
          .slice(0, 1)
          .toUpperCase()}${this.$route.params.shape.slice(1)}`;
        this.filters.initialFilters.diamondShape = shapename;
      } else if (this.$route.params.shape == undefined) {
        this.filters.initialFilters.diamondShape = "";
      }
    },
    windowResizing() {
      this.windowInnerwidth = `${window.innerWidth}px`;
    },
    handleScroll() {
      var fixedElement = document.querySelector(".pc-mobile-show-results");
      var scrollY = element?.scrollY || element?.pageYOffset;
      if (scrollY > 100) {
        // Adjust this value based on when you want the element to become "fixed"
        fixedElement.classList.add("fixed");
      } else {
        fixedElement.classList.remove("fixed");
      }
    },
    shipDiamond(e, type) {
      this.filters.initialFilters[type] = e.target.checked;
      this.saveAppliedFilters();
    },
    addCompare(diamond) {
      if (
        this.compareDiamondArray.filter((v) => v.diamondId == diamond.diamondId)
          .length
      ) {
        this.compareDiamondArray = this.compareDiamondArray.filter((v) => {
          return v.diamondId != diamond.diamondId;
        });
      } else {
        this.compareDiamondArray.push(diamond);
      }
    },
    openPopup(e, num) {
      e.stopPropagation();
      this.isTooltipVisible = this.isTooltipVisible === num ? "" : num;
    },
    closeTooltipOnOutsideClick(event) {
      const tooltip = document.querySelector(".tooltip");
      if (
        this.isTooltipVisible !== "" &&
        tooltip &&
        !tooltip.contains(event.target)
      ) {
        this.isTooltipVisible = "";
      }
    },
    /* step slider */
    removeStepSliderFilter(stepSliderFilterType, filterType) {
      this.filters.initialFilters[filterType] = [];
      this.filters.initialFilters[stepSliderFilterType].value = [
        this.filters[stepSliderFilterType].min,
        this.filters[stepSliderFilterType].max,
      ];
      this.applyFilters();
    },
    /* step slider */
    preventSliderIfValueExceed(stepSliderFilterType) {
      var currentSliderRange =
        this.filters.initialFilters[stepSliderFilterType].value;
      var currentSliderRangeMinVal = currentSliderRange[0];
      var currentSliderRangeMaxVal = currentSliderRange[1];
      var currentSliderRangeDefaultMinVal =
        this.filters[stepSliderFilterType].min;
      var currentSliderRangeDefaultMaxVal =
        this.filters[stepSliderFilterType].max;
      if (currentSliderRangeMinVal == currentSliderRangeMaxVal) {
        if (
          currentSliderRangeMinVal == currentSliderRangeDefaultMinVal &&
          currentSliderRangeMaxVal == currentSliderRangeDefaultMinVal
        ) {
          currentSliderRangeMaxVal++;
        } else if (
          currentSliderRangeMinVal == currentSliderRangeDefaultMaxVal &&
          currentSliderRangeMaxVal == currentSliderRangeDefaultMaxVal
        ) {
          currentSliderRangeMinVal--;
        } else if (currentSliderRangeMinVal >= currentSliderRangeMaxVal) {
          currentSliderRangeMinVal--;
        } else if (currentSliderRangeMaxVal <= currentSliderRangeMinVal) {
          currentSliderRangeMaxVal++;
        }
        this.filters.initialFilters[stepSliderFilterType].value = [
          currentSliderRangeMinVal,
          currentSliderRangeMaxVal,
        ];
      }
    },
    /* step slider */
    applyStepSliderFilter(
      stepSliderFilterType,
      filterType,
      filterOptions = []
    ) {
      var appliedFilterOptions = [];
      this.filters.initialFilters[filterType] = [];
      var currentSliderRange =
        this.filters.initialFilters[stepSliderFilterType].value;
      for (
        var optionIndex = currentSliderRange[0];
        optionIndex < currentSliderRange[1];
        optionIndex++
      ) {
        appliedFilterOptions.push(filterOptions[optionIndex]);
      }
      if (
        appliedFilterOptions.length != this.filters[stepSliderFilterType].max
      ) {
        this.filters.initialFilters[filterType].push(...appliedFilterOptions);
      }
      this.applyFilters();
    },
    /* step slider */
    makeListHeaderSticky() {
      if (this.isComponentMounted) {
        var headerEl = document.querySelector(".list-header.sorter");
        if (headerEl) {
          var headerElPos =
            headerEl.getBoundingClientRect().top + window.pageYOffset;
          var windowScrollYPos = window.pageYOffset;
          if (windowScrollYPos > headerElPos) {
            headerEl.classList.add("sticky-header");
          } else {
            headerEl.classList.remove("sticky-header");
          }
        }
      }
    },
    handleGridTabLabel() {
      this.gridTabLabel =
        this.filters.initialFilters.selectedDiamondTab != "gemstone"
          ? "Diamonds Found"
          : "Gemstones Found";
    },
    handleSortFields() {
      this.$options.gemstoneSortFields.forEach((gemstoneSortField) => {
        this.filters.initialFilters.sortFields[gemstoneSortField].showField =
          this.filters.initialFilters.selectedDiamondTab == "gemstone"
            ? true
            : false;
      });
    },
    handleDiamondRatioFilter() {
      var appliedLengthMin = this.filters.initialFilters.gemstoneLengthMin;
      var appliedLengthMax = this.filters.initialFilters.gemstoneLengthMax;
      var appliedWidthMin = this.filters.initialFilters.gemstoneWidthMin;
      var appliedWidthMax = this.filters.initialFilters.gemstoneWidthMax;

      var defaultLengthMin = this.filters.gemstoneDefaultLengthMin;
      var defaultLengthMax = this.filters.gemstoneDefaultLengthMax;
      var defaultWidthMin = this.filters.gemstoneDefaultWidthMin;
      var defaultWidthMax = this.filters.gemstoneDefaultWidthMax;

      if (
        !appliedLengthMin ||
        appliedLengthMin < defaultLengthMin ||
        appliedLengthMin > defaultLengthMax
      ) {
        this.filters.initialFilters.gemstoneLengthMin = defaultLengthMin;
        appliedLengthMin = defaultLengthMin;
      }
      if (
        !appliedLengthMax ||
        appliedLengthMax < defaultLengthMin ||
        appliedLengthMax > defaultLengthMax
      ) {
        this.filters.initialFilters.gemstoneLengthMax = defaultLengthMax;
        appliedLengthMax = defaultLengthMax;
      }
      if (
        !appliedWidthMin ||
        appliedWidthMin < defaultWidthMin ||
        appliedWidthMin > defaultWidthMax
      ) {
        this.filters.initialFilters.gemstoneWidthMin = defaultWidthMin;
        appliedWidthMin = defaultWidthMin;
      }
      if (
        !appliedWidthMax ||
        appliedWidthMax < defaultWidthMin ||
        appliedWidthMax > defaultWidthMax
      ) {
        this.filters.initialFilters.gemstoneWidthMax = defaultWidthMax;
        appliedWidthMax = defaultWidthMax;
      }
      this.applyFilters();
    },
    /* price range slider section */
    setRangePricesInArray() {
      this.priceRangeArr = [];
      var startPrice = parseInt(diamondMinPrice);
      var endPrice = parseInt(diamondMaxPrice);
      for (var price = startPrice; price < 1200; price = price + 50) {
        this.priceRangeArr.push(price);
      }
      for (var price = 1200; price < 12000; price = price + 100) {
        this.priceRangeArr.push(price);
      }
      for (var price = 12000; price < 25000; price = price + 500) {
        this.priceRangeArr.push(price);
      }
      for (var price = 25000; price < 40000; price = price + 1000) {
        this.priceRangeArr.push(price);
      }
      for (var price = 40000; price < 100000; price = price + 5000) {
        this.priceRangeArr.push(price);
      }
      for (var price = 100000; price <= endPrice; price = price + 10000) {
        this.priceRangeArr.push(price);
      }
      var priceMinIndex = 0;
      var priceMaxIndex = this.priceRangeArr.length - 1;
      this.filters.price.min = priceMinIndex;
      this.filters.price.max = priceMaxIndex;
      this.filters.initialFilters.price.value[0] = priceMinIndex;
      this.filters.initialFilters.price.value[1] = priceMaxIndex;
      this.filters.initialFilters.priceTxtFields.minPrice =
        this.defaultMinPrice;
      this.filters.initialFilters.priceTxtFields.maxPrice =
        this.defaultMaxPrice;
    },
    applyPriceFilterOnSlide() {
      this.applyFilters();
    },
    handlePriceFields(checkStoredPrices = false, maxPrice = 0) {
      var minPriceIndex = this.filters.initialFilters.price.value[0];
      var maxPriceIndex = this.filters.initialFilters.price.value[1];
      var minSlidePrice = this.getPriceByArrayIndex(minPriceIndex);
      var maxSlidePrice = !!maxPrice ? maxPrice : this.getPriceByArrayIndex(maxPriceIndex);
      if (checkStoredPrices) {
        if (sessionStorage.getItem("storedMinPrice")) {
          this.filters.initialFilters.priceTxtFields.minPrice =
            sessionStorage.getItem("storedMinPrice");
          sessionStorage.removeItem("storedMinPrice");
          return;
        }
        if (sessionStorage.getItem("storedMaxPrice")) {
          this.filters.initialFilters.priceTxtFields.maxPrice =
            sessionStorage.getItem("storedMaxPrice");
          sessionStorage.removeItem("storedMaxPrice");
          return;
        }
      }
      this.filters.initialFilters.priceTxtFields.minPrice = minSlidePrice;
      this.filters.initialFilters.priceTxtFields.maxPrice = maxSlidePrice;
    },
    getPriceByArrayIndex(index) {
      return this.priceRangeArr[index];
    },
    getArrayIndexByPrice(price) {
      var priceArr = this.priceRangeArr;
      var closest = priceArr[0];
      for (var index = 0; index < priceArr.length; index++) {
        closestDiff = Math.abs(price - closest);
        currentDiff = Math.abs(price - priceArr[index]);
        if (currentDiff < closestDiff) {
          closest = priceArr[index];
        }
      }
      return priceArr.indexOf(closest);
    },
    injectCurrentDiamondType(diamondType) {

      var urlParam = diamondType
      var diamondTab =
        urlParam.toLowerCase() == "natural-fancy-coloured-diamonds"
          ? "white_color"
          : urlParam.toLowerCase() == "coloured-lab-grown-diamonds"
            ? "lab_color"
            : urlParam.toLowerCase() == "natural-diamonds"
              ? "white"
              : urlParam.toLowerCase() == "lab-diamonds"
                ? "lab"
                : urlParam.toLowerCase();
      this.filters.initialFilters.selectedDiamondTab = diamondTab;
    },
    handleRecentlyViewedDiamonds() {
      if (sessionStorage.getItem("ringbuilderRecentlyViewForListing")) {
        var recentlyViewedDiamonds = JSON.parse(
          sessionStorage.getItem("ringbuilderRecentlyViewForListing")
        );
        this.recentDiamondsCount = recentlyViewedDiamonds.length;
        this.recentDiamonds = recentlyViewedDiamonds.length
          ? this.getPriceConvertedRecentDiamonds(recentlyViewedDiamonds)
          : [];
      }
      if (this.recentDiamondsCount === 0 && this.currentTab === 'recent') {
        this.currentTab = 'diamond';
      }
    },
    getPriceConvertedRecentDiamonds(recentDiamonds = []) {
      var convertedDiamonds = [];
      recentDiamonds.forEach((recentDiamond) => {
        recentDiamond = getCurrencyWiseDiamond(recentDiamond);
        convertedDiamonds.push(recentDiamond);
      });
      return convertedDiamonds;
    },
    isInViewport(element) {
      const box = element?.getBoundingClientRect();
      return box?.top - 300 < window.innerHeight && box?.bottom >= 0;
    },
    sendRequestOnWindowScroll() {
      if (this.isComponentMounted) {
        var compareTab =
          document.getElementsByClassName("pc-sub-tab compare")[0];
        var recentTab = document.getElementsByClassName("pc-sub-tab recent")[0];
        // if ((compareTab && !compareTab.classList.contains("active")) && (recentTab && !recentTab.classList.contains("active"))) {
        if (this.currentTab === "diamond") {
          const totalPages = Math.ceil(
            this.diamondCount / this.$options.resultLimit
          );
          // if (this.page > totalPages) return
          var footerElement = document.getElementsByClassName(
            "choose-diamond-footer"
          )[0];
          if (
            this.isInViewport(footerElement) &&
            this.sendRequest &&
            parseInt(this.diamondCount) - this.items.length > 0
          ) {
            this.loadMore();
          }
        }
      }
    },

    handleLoadMoreButtonClick() {
      this.isLoadMoreBtnActive = false; // Hide button after first click
      this.loadMore(); // Start loading
    },

    initDiamondGridScroll() {
      if (document.getElementById("infinite-list")) {
        document
          .getElementById("infinite-list")
          .scrollTo({ top: 0, behavior: "smooth" });
      }
    },
    loadCachedData() {
      /* set current page and scrolled diamond list from cached session storage */
      var diamondFilter = sessionStorage.getItem(
        `${this.filters.initialFilters.selectedDiamondTab}DiamondsAppliedFilters`
      );
      if (
        JSON.stringify(this.filters.initialFilters) == diamondFilter &&
        this.getCurrentPageFromSession() != null &&
        this.getDiamondsFromSession().length &&
        this.getDiamondCountFromSession() != null &&
        sessionStorage.getItem("isDiamondDetailPageViewed") != null
      ) {
        this.loading = false;
        this.dataNotFound = false;
        this.page = parseInt(this.getCurrentPageFromSession());

        this.items = this.getDiamondsFromSession();
        this.diamondCount = parseInt(this.getDiamondCountFromSession());
        if (this.diamondCount < 20) {
          document.removeEventListener("scroll", this.handleScroll);
        } else {
          window.addEventListener("scroll", () => {
            this.sendRequestOnWindowScroll();
            this.makeListHeaderSticky();
          });
        }
        this.loadRecentDiamond();
        this.scrollToRecentDiamond();
      } else {
        if (!sessionStorage.getItem("preventCaratAndClarity")) {
          var hasMaxPriceQuery = !!(this.$route && this.$route.query && this.$route.query.maxPrice);
          /* remove diamondlist and current page from cached session before load new diamonds from ajax */
          if (
            this.filters.initialFilters.selectedDiamondTab == "lab" ||
            this.filters.initialFilters.selectedDiamondTab == "lab_color"
          ) {
            if (this.isValidCaratPage(this.$route.params.shape)) {
              const carat = this.parseCaratValue(this.$route.params.shape);
              if (Number(carat)) {
                this.filters.initialFilters.carat.value[0] = Number(carat);
              }
            } else {
              this.filters.initialFilters.carat.value = [1.5, 10];
            }
            if (!hasMaxPriceQuery) {
              this.filters.initialFilters.clarityRange.value = [0, 4];
              this.filters.initialFilters.clarity = ["FL", "IF", "VVS1", "VVS2"];
            }
          } else {
            if (this.isValidCaratPage(this.$route.params.shape)) {
              const carat = this.parseCaratValue(this.$route.params.shape);
              if (Number(carat)) {
                this.filters.initialFilters.carat.value[0] = Number(carat);
              }
            } else {
              this.filters.initialFilters.carat.value = [1, 10];
            }
            this.filters.initialFilters.clarityRange.value = [0, 7];
            this.filters.initialFilters.clarity = [];
          }
          sessionStorage.setItem("preventCaratAndClarity", true);
        }
        this.removeDiamondMetaData();
        this.loadMore();
      }
    },
    loadRecentDiamond() {
      if (sessionStorage.getItem("ringbuilderRecentlyView")) {
        var recentlyViewedDiamonds = JSON.parse(
          sessionStorage.getItem("ringbuilderRecentlyView")
        );
        if (recentlyViewedDiamonds != null) {
          var lastRecentDiamond = recentlyViewedDiamonds.pop();
          this.recentDiamondId = lastRecentDiamond.diamondId;
        }
      }
    },
    scrollToRecentDiamond() {
      setTimeout(() => {
        var elementUptoScroll = document.querySelector(
          `.pc-diamond-${this.recentDiamondId}`
        );
        if (elementUptoScroll != undefined || elementUptoScroll != null) {
          elementUptoScroll.classList.add("pc-highlight_item");
          elementUptoScroll.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
          sessionStorage.removeItem("isDiamondDetailPageViewed");
        }
      }, 1000);
    },
    handleFilters(e, filterType) {
      isRangeFilter = 0;
      if (
        filterType == "color" &&
        this.$options.rapnetRequestDiamonds.includes(
          this.filters.initialFilters.selectedDiamondTab
        )
      ) {
        isRangeFilter = 1;
      } else if (
        filterType == "diamondShape" ||
        filterType == "fluroscence" ||
        filterType == "labs"
      ) {
        isRangeFilter = 0;
      } else {
        if (
          this.$options.rapnetRequestDiamonds.includes(
            this.filters.initialFilters.selectedDiamondTab
          )
        ) {
          isRangeFilter = 1;
        } else {
          isRangeFilter = 0;
        }
      }
      if (isRangeFilter && this.filters.initialFilters[filterType].length) {
        var newValues = [];
        var originalFilterValues = this.getComputedProperties(filterType);
        var currentValue = e.target.value;
        var currentValueArrIndex = originalFilterValues.indexOf(currentValue);
        var startPointValue = this.filters.initialFilters[filterType][0];
        var endPointValue =
          this.filters.initialFilters[filterType][
          this.filters.initialFilters[filterType].length - 1
          ];
        var startPointArrIndex = originalFilterValues.indexOf(startPointValue);
        var endPointArrIndex = originalFilterValues.indexOf(endPointValue);
        if (
          startPointArrIndex < currentValueArrIndex &&
          endPointArrIndex > currentValueArrIndex
        ) {
          endPointArrIndex = currentValueArrIndex;
        } else if (
          currentValueArrIndex < startPointArrIndex &&
          currentValueArrIndex > endPointArrIndex
        ) {
          startPointArrIndex = currentValueArrIndex;
        }
        var direction = startPointArrIndex <= endPointArrIndex ? "ltr" : "rtl";
        if (direction == "ltr") {
          for (var i = startPointArrIndex; i <= endPointArrIndex; i++) {
            newValues.push(originalFilterValues[i]);
          }
        } else {
          for (var i = startPointArrIndex; i >= endPointArrIndex; i--) {
            newValues.push(originalFilterValues[i]);
          }
        }
        this.filters.initialFilters[filterType] = newValues;
      }
      this.applyFilters();
    },
    getComputedProperties(filterType) {
      if (filterType == "color") {
        return this.getColor;
      } else if (filterType == "cut") {
        return this.getCut;
      } else if (filterType == "clarity") {
        return this.getClarity;
      } else if (filterType == "polish") {
        return this.getPolish;
      } else if (filterType == "symmetry") {
        return this.getSymmetry;
      }
    },
    handleBannerTitle() {
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "diamondPage") {
        this.showBannerTitle = true;
      }
    },
    initializeSteps() {
      /* init steps if user reset from same page */
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "settingPage") {
        this.stepData = {
          firstStep: { headerTitle: "SETTING" },
          secondStep: { headerTitle: "DIAMOND" },
          thirdStep: { headerTitle: "Ring" },
        };
      } else {
        this.stepData = {
          firstStep: { headerTitle: "DIAMOND" },
          secondStep: { headerTitle: "SETTING" },
          thirdStep: { headerTitle: "Ring" },
        };
      }
      /* after reset, highlight current step */
      this.totalSteps = (firstPage == "settingPage") ? 2 : 1;
      /* init sticky items if user reset from same page */
      this.pageStickyItems = [];
      this.resetFilters();
    },
    handleSelectedSettingShapes() {
      var firstPage = sessionStorage.getItem("firstPage");
      // Rebuilt on every call (this runs again on each diamond-type tab
      // switch); left empty without a setting, so every shape stays enabled.
      this.settingCanBeSetWithShapes = [];
      if (sessionStorage.getItem("selectedSetting")) {
        /* set setting's can be set with shapes */
        var selectedSetting = JSON.parse(
          sessionStorage.getItem("selectedSetting")
        );
        const allShapes =
          selectedSetting?.attributes?.This_Ring_Can_Be_Set_With || [];

        let allSecondShapes = selectedSetting?.secondShapes || ""; // yaha string hoga
        allSecondShapes = allSecondShapes?.trim();

        // A malformed value would otherwise stop the shape below from being set.
        let parsed = [];
        try {
          parsed = !!allSecondShapes ? JSON.parse(allSecondShapes) : [];
        } catch (e) {
          console.warn("Invalid setting secondShapes:", e);
        }

        // sabhi values extract karo
        let allParsedSecondShapes = parsed
          .map((obj) => Object.values(obj))
          .flat();
        const isSecondDiamondSearching = sessionStorage.getItem(
          "searchingSecondDiamond"
        );
        // duplicates remove karo
        let uniqueShapes = [...new Set(allParsedSecondShapes)];

        const compatibleShapes =
          uniqueShapes.length &&
          sessionStorage.getItem("selectedDiamond") &&
          isSecondDiamondSearching
            ? uniqueShapes
            : allShapes;
        // The shapes on the setting's page, in this list's spelling. They drive
        // the disabled shape filters (isShapeDisabled) and are the shapes
        // requested while no single shape is picked. The setting page saves an
        // array; a comma-separated string is read as well.
        this.settingCanBeSetWithShapes = [
          ...new Set(
            [compatibleShapes]
              .flat()
              .flatMap((shape) => `${shape || ""}`.split(","))
              .map((shape) => this.toListShape(shape))
              .filter((shape) => shape)
          ),
        ];
        // Stored as a single string: the shape radios' v-model only checks a
        // radio for a matching string, never for a one-item array.
        if (
          uniqueShapes.length &&
          sessionStorage.getItem("selectedDiamond") &&
          isSecondDiamondSearching
        ) {
          this.filters.initialFilters.diamondShape = this.toListShape(uniqueShapes[0]);
        } else if (
          !this.isValidShape() ||
          this.isShapeDisabled(this.$route.params.shape)
        ) {
          // A shape in the url (clicked on this list, or the link opened on
          // one) is already applied by updateDiamondShape() and stays, as long
          // as the setting can hold it. Otherwise start on the setting's shape.
          const settingOptions = safeParseJSON("selectedSettingOptions");
          const settingShape = this.toListShape(
            selectedSetting.selectedDiamondShape ||
              settingOptions?.settingDiamondShape
          );
          this.filters.initialFilters.diamondShape = settingShape;
          // The url named a shape this setting can't hold: move it to the shape
          // shown, so the url, breadcrumb and page title match the list.
          if (this.isValidShape() && this.isValidShape(settingShape)) {
            this.$router.replace({
              path: `/${this.$route.params.diamondType}/${settingShape.toLowerCase()}`,
            });
          }
        }

        /* set applied shapes of setting listing */
        /* if (sessionStorage.getItem("chooseSettingsAppliedFilters")) {
                    var settingListingAppliedFilters = JSON.parse(sessionStorage.getItem("chooseSettingsAppliedFilters"))
                    var settingSelectedShapes = settingListingAppliedFilters.shapes
                    if (settingSelectedShapes.length) {
                        settingSelectedShapes.split(',').map((settingShape) => {
                            settingShape = settingShape.trim().toLowerCase()
                            settingShape = settingShape.charAt(0).toUpperCase() + settingShape.slice(1)
                            if (!this.filters.initialFilters.diamondShape.includes(settingShape)) {
                                this.filters.initialFilters.diamondShape.push(settingShape)
                            }
                        })
                    }
                } */
      }
      /* set diamond shape chosen by user on setting detail page */
      /* if (sessionStorage.getItem("selectedSettingOptions")) {
                var settingConfigOptions = JSON.parse(sessionStorage.getItem("selectedSettingOptions"))
                if (settingConfigOptions.hasOwnProperty("settingDiamondShape")) {
                    var settingDiamondShape = settingConfigOptions.settingDiamondShape
                    settingDiamondShape = settingDiamondShape.trim().toLowerCase()
                    settingDiamondShape = settingDiamondShape.charAt(0).toUpperCase() + settingDiamondShape.slice(1)
                    if (!this.filters.initialFilters.diamondShape.includes(settingDiamondShape)) {
                        if(Array.isArray(this.filters.initialFilters.diamondShape)){
                            this.filters.initialFilters.diamondShape.push(settingDiamondShape)
                        } else {
                            this.filters.initialFilters.diamondShape = this.filters.initialFilters.diamondShape.split(',').filter(v=>v)
                            this.filters.initialFilters.diamondShape.push(settingDiamondShape)
                        }
                    }
                }
            } */
    },
    handleStepData() {
      if (sessionStorage.getItem("stepData")) {
        this.stepData = JSON.parse(sessionStorage.getItem("stepData"));
        // Guard against a stale/mismatched cache: only trust a step's cached title/price
        // if it still points at what's actually selected right now. Prevents a step
        // showing blank (or the wrong item) when the cache wasn't updated in lockstep
        // with the real selection.
        var realSetting = safeParseJSON("selectedSetting");
        var realDiamond = safeParseJSON("selectedDiamond");
        ["firstStep", "secondStep"].forEach((key) => {
          var step = this.stepData[key];
          if (!step) return;
          if (step.page === "setting" && (!realSetting || String(step.id) !== String(realSetting.id))) {
            this.stepData[key] = { headerTitle: step.headerTitle };
          } else if (step.page === "diamond" && (!realDiamond || String(step.id) !== String(realDiamond.diamondId))) {
            this.stepData[key] = { headerTitle: step.headerTitle };
          }
        });
      }
      if (sessionStorage.getItem("firstPage")) {
        var firstPage = sessionStorage.getItem("firstPage");
        if (firstPage == "settingPage") {
          this.stepData.firstStep.headerTitle = "SETTING";
          this.stepData.secondStep.headerTitle = "DIAMOND";
          /* handle setting price for first step */
          this.stepData.firstStep = this.getConvertedStepPrice(
            this.stepData.firstStep
          );
          /* handle diamond price for second step */
          this.stepData.secondStep = this.getConvertedStepPrice(
            this.stepData.secondStep
          );
        } else if (firstPage == "diamondPage") {
          this.stepData.firstStep.headerTitle = "DIAMOND";
          this.stepData.secondStep.headerTitle = "SETTING";
          /* handle setting price for second step */
          this.stepData.secondStep = this.getConvertedStepPrice(
            this.stepData.secondStep
          );
          /* handle diamond price for first step */
          this.stepData.firstStep = this.getConvertedStepPrice(
            this.stepData.firstStep
          );
        }
        /* handle third step as per currency */
        this.stepData.thirdStep = this.getConvertedStepPrice(
          this.stepData.thirdStep
        );
      }
      /* calculate totalSteps based on which steps actually have selections */
      var count = 0;
      if (this.stepData.firstStep && this.stepData.firstStep.title) count++;
      if (this.stepData.secondStep && this.stepData.secondStep.title) count++;
      if (this.stepData.thirdStep && this.stepData.thirdStep.title) count++;
      /* ensure current step (diamond) is at least highlighted */
      var firstPage = sessionStorage.getItem("firstPage");
      var currentStepPos = (firstPage == "settingPage") ? 2 : 1;
      this.totalSteps = Math.max(count, currentStepPos);
    },
    getConvertedStepPrice(step) {
      if (step.hasOwnProperty("price")) {
        step = getCurrencyWiseStep(step);
      }
      return step;
    },
    handleStickyBarItems() {
      if (sessionStorage.getItem("stickyBarItems")) {
        this.pageStickyItems = this.getConvertedStickyBarItems(
          JSON.parse(sessionStorage.getItem("stickyBarItems"))
        );
      }
    },
    getConvertedStickyBarItems(stickyBarItems) {
      if (stickyBarItems.length) {
        stickyBarItems.map((stickyBarItem) => {
          if (stickyBarItem.hasOwnProperty("price")) {
            stickyBarItem = getCurrencyWiseStickyItem(stickyBarItem);
          }
        });
      }
      return stickyBarItems;
    },
    toggleFAQLab(index) {
      this.faqsLab[index].open = !this.faqsLab[index].open;
    },
    toggleFAQColorLab(index) {
      this.faqsColorLab[index].open = !this.faqsColorLab[index].open;
    },
    toggleFAQNatural(index) {
      this.faqsNatural[index].open = !this.faqsNatural[index].open;
    },
    toggleFAQColorNatural(index) {
      this.faqsColorNatural[index].open = !this.faqsColorNatural[index].open;
    },
    toggleCaratFaq(index) {
      this.caratFaqsOpen[index] = !this.caratFaqsOpen[index];
    },
    changeDiamondTab(e, diamondTab) {

      var diamondType = `${diamondTab.toLowerCase() == "white"
        ? "natural"
        : diamondTab.toLowerCase()
        }-diamonds`;
      if (sessionStorage.getItem("firstPage") == "diamondPage") {
        this.filters.initialFilters.selectedDiamondTab = diamondTab;
        var shape = this.filters.initialFilters.diamondShape;
        var shapename = Array.isArray(shape)
          ? shape.filter((v) => v).length
            ? shape.filter((v) => v)[0].toLowerCase()
            : ""
          : shape.toLowerCase();
        var link =
          diamondTab === "white"
            ? "natural-diamonds"
            : diamondTab === "lab"
              ? "lab-diamonds"
              : diamondTab === "white_color"
                ? "natural-fancy-coloured-diamonds"
                : diamondTab === "lab_color"
                  ? "coloured-lab-grown-diamonds"
                  : diamondTab;
        var compName = shape
          ? diamondTab === "white"
            ? "naturalDiamondsbyshape"
            : "labDiamondsbyshape"
          : diamondTab === "white"
            ? "naturalDiamonds"
            : "labDiamonds";
        var carat_slug = null;
        if (this.isValidCaratPage()) {
          carat_slug = this.$route.params.shape;
        }
        this.$router.push({
          path: `/${link}/${`${(!!carat_slug ? carat_slug : shapename) || ""
            }`}`,
        });
        this.applyFilters();
        // this.handleBreadcrumbs(diamondTab)
      } else {
        this.filters.initialFilters.selectedDiamondTab = diamondTab;
        var shape = this.filters.initialFilters.diamondShape;
        var shapename = Array.isArray(shape)
          ? shape.filter((v) => v).length
            ? shape.filter((v) => v)[0].toLowerCase()
            : ""
          : shape.toLowerCase();
        var link =
          diamondTab === "white"
            ? "natural-diamonds"
            : diamondTab === "lab"
              ? "lab-diamonds"
              : diamondTab === "white_color"
                ? "natural-fancy-coloured-diamonds"
                : diamondTab === "lab_color"
                  ? "coloured-lab-grown-diamonds"
                  : "";
        var compName = shape
          ? diamondTab === "white"
            ? "naturalDiamondsbyshape"
            : "labDiamondsbyshape"
          : diamondTab === "white"
            ? "naturalDiamonds"
            : "labDiamonds";
        this.$router.push({
          path: `/${link}${shapename ? `/${shapename}` : ""}`,
        });
        this.applyFilters();
      }
    },
    isMobile() {
      return this.isMobileView;
    },
    setNewImage(targetElement, diamond, resultView) {
      var stage = parseInt(targetElement.dataset.imgErrorStage || "0");
      targetElement.dataset.imgErrorStage = String(stage + 1);
      if (stage === 0) {
        var isGemstone = typeof diamond === "object" && diamond !== null && diamond.diamondType === "gemstone";
        var shapeName = typeof diamond === "string" ? diamond : (diamond && diamond.shape);
        targetElement.setAttribute(
          "src",
          isGemstone ? getGemstoneSampleImg(diamond) : getShapeFallbackImage(shapeName)
        );
      } else if (stage === 1) {
        targetElement.setAttribute("src", shapeToImageUrl.DEFAULT);
      }
    },
    getParentElement(targetElement, parentElementToFind) {
      var nodes = [];
      var element = targetElement;
      while (element?.parentNode) {
        if (element?.parentNode.tagName.toLowerCase() == parentElementToFind) {
          nodes = [];
          nodes.unshift(element?.parentNode);
          break;
        }
        nodes.unshift(element?.parentNode);
        element = element?.parentNode;
      }
      return nodes[0];
    },
    getChildElement(targetElement, className) {
      var element;
      const collection = targetElement.children;
      for (let i = 0; i < collection.length; i++) {
        if (collection[i].classList.contains(className)) {
          element = collection[i];
          break;
        }
      }
      return element;
    },
    handleReactiveTooltip(isChecked, diamond) {
      if (
        this.compareDiamondArray.filter((v) => v.diamondId == diamond.diamondId)
          .length
      ) {
        this.handleTooltip(
          this.$t("Removed from compare list"),
          "pc-tooltip-inactive"
        );
      } else {
        this.handleTooltip(this.$t("Diamond added in compare list"), "");
      }
    },
    handleTooltip(tooltipMsg, tooltipClass) {
      if (this.timeOutId) clearTimeout(this.timeOutId);
      this.showTooltip = true;
      this.tooltipText = tooltipMsg;
      this.tooltipClass = tooltipClass;
      this.timeOutId = setTimeout(() => {
        this.showTooltip = false;
        this.tooltipText = "";
        this.tooltipClass = "";
      }, 1000);
    },
    /* Trail on a diamond listing page, e.g.
       "Coloured Lab Grown Diamonds / Round Coloured Lab Grown Diamonds".
       The shape crumb is only added once a single shape is in play. */
    handleBreadcrumbs(diamondType = this.$route.params.diamondType) {
      var typeLabel = this.getDiamondTypeLabel(diamondType);
      var trail = [
        {
          path: `${vueBaseUrl}${diamondType}`,
          name: `${typeLabel} Diamonds`,
        },
      ];

      var shapeLabel = this.getSelectedShapeLabel();
      var caratLabel = this.isValidCaratPage()
        ? `${this.parseCaratValue(this.$route.params.shape)} Carat`
        : "";

      if (shapeLabel || caratLabel) {
        var shapeSlug =
          this.$route.params.shape || shapeLabel.toLowerCase();
        trail.push({
          path: `${vueBaseUrl}${diamondType}/${shapeSlug}`,
          name: [shapeLabel, caratLabel, typeLabel, "Diamonds"]
            .filter((part) => !!part)
            .join(" "),
        });
      }

      this.breadcrumbs = trail;
    },
    getDiamondTypeLabel(diamondType = this.$route.params.diamondType) {
      var type = `${diamondType || ""}`.toLowerCase();
      if (type.includes("coloured-lab-grown") || type.includes("lab_color")) {
        return "Coloured Lab Grown";
      }
      if (
        type.includes("natural-fancy-coloured") ||
        type.includes("natural-color")
      ) {
        return "Coloured Natural";
      }
      if (type.includes("lab")) {
        return "Lab Grown";
      }
      if (type.includes("natural")) {
        return "Natural";
      }
      return this.toTitleCase(
        type.replace(/-?diamonds?$/, "").replace(/-/g, " ")
      );
    },
    /* Only name the shape when a single one is selected — a multi-shape filter
       has no one shape to put in the trail. */
    getSelectedShapeLabel() {
      var shape = this.filters.initialFilters.diamondShape;
      var shapes = Array.isArray(shape)
        ? shape.filter((v) => v)
        : shape
          ? [shape]
          : [];
      if (shapes.length == 1) {
        return this.toTitleCase(shapes[0]);
      }
      // A deep link lands on /<type>/<shape> before the filter is populated.
      if (!shapes.length && this.isValidShape()) {
        return this.toTitleCase(this.$route.params.shape);
      }
      return "";
    },
    toTitleCase(value) {
      return `${value || ""}`
        .split(" ")
        .filter((word) => word)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(" ");
    },
    // A setting's shape in this list's spelling ("EMERALD" -> "Emerald"), so the
    // matching shape radio is the one checked. Shapes the list has no filter
    // for are kept as given and still sent to the API.
    toListShape(shape) {
      const value = `${shape || ""}`.trim();
      return (
        this.getDiamondShapes.find(
          (s) => s.toLowerCase() === value.toLowerCase()
        ) || value
      );
    },
    // A shape the chosen setting isn't offered in: its filter is disabled.
    // Nothing is disabled until a setting is chosen.
    isShapeDisabled(shape) {
      const value = `${shape || ""}`.trim().toLowerCase();
      return (
        this.settingCanBeSetWithShapes.length > 0 &&
        !this.settingCanBeSetWithShapes.some((s) => s.toLowerCase() === value)
      );
    },
    isValidShape(shape = this.$route.params.shape) {
      // Return false if shape is falsy
      if (!shape) {
        return false;
      }

      const lowerShapes = this.getDiamondShapes.map((s) => s.toLowerCase());

      // No pattern: check if input is a valid shape
      return lowerShapes.includes(shape.toLowerCase());
    },
    isValidCaratPage(shape = this.$route.params.shape) {
      if (!shape) {
        return;
      }
      // Regular expression for pattern: <number>-carat-diamond-<shape>-<number>
      const pattern = /^([\d\-]+)-carat-diamond$/i;
      // Check if input matches the pattern
      const match = shape.match(pattern);
      if (!!match) {
        // Pattern matched: validate the shape part
        return shape == match[0];
      }

      return false;
    },
    parseCaratValue(data) {
      // Remove suffix and extract the numeric part
      const match = data.match(/^([\d\-]+)-carat-diamond$/i);
      if (!match) return null;

      const parts = match[1].split("-").map(Number);

      if (parts.length === 1) {
        // e.g., 1-carat-diamond
        return parts[0];
      } else if (parts.length === 2) {
        // e.g., 1-5-carat-diamond => 1.5
        return parseFloat(`${parts[0]}.${parts[1]}`);
      } else if (parts.length === 3) {
        // e.g., 0-50-0-carat-diamond => 0.50
        return parseFloat(`${parts[0]}.${parts[1]}`);
      }

      return null;
    },
    getDiamondType(type = this.$route.params.diamondType) {
      if (!!type) {
        switch (type) {
          case "natural-diamonds":
            return "Natural Diamond";
          case "lab-diamonds":
            return "Lab Grown Diamond";
          case "coloured-lab-grown-diamonds":
            return "Lab Colour Diamond";
          case "natural-fancy-coloured-diamonds":
            return "Natural Colour Diamond";
          default:
            return "Diamond";
        }
      } else {
        return "Diamond";
      }
    },

    setDynamicCaratPageMetaData(data = this.$route.params.shape) {
      if (!data) return;

      const carat = this.parseCaratValue(data);

      let metaTitle = null;
      let metaDescription = null;

      if (this.getDiamondType() == "Natural Diamond") {
        metaTitle = `${carat} Carat Natural Diamond Rings Australia | Certified Quality | Rings of Australia`;
        metaDescription = `Shop stunning ${carat} carat lab-grown diamond rings in Australia at Rings of Australia. Affordable, ethical, and eco-friendly – perfect for modern love. Discover your forever ring today!`;
      } else if (this.getDiamondType() == "Lab Grown Diamond") {
        metaTitle = `${carat} Carat Lab Grown Diamond Rings Australia | Ethically Sourced | Rings of Australia`;
        metaDescription = `Shop stunning ${carat} carat lab-grown diamond rings in Australia at Rings of Australia. Affordable, ethical, and eco-friendly – perfect for modern love. Discover your forever ring today!`;
      } else if (this.getDiamondType() == "Lab Colour Diamond") {
        metaTitle = `Shop Lab Grown Coloured Diamond Engagement Rings | 30% OFF`;
        metaDescription = `Buy coloured lab-grown diamond engagement rings online. Save thousands on pink & yellow diamonds + 30% OFF | Certified quality | FREE shipping Australia-wide`;
      } else if (this.getDiamondType() == "Natural Colour Diamond") {
        metaTitle = `Certified Natural Coloured Diamonds for Your Engagement Ring`;
        metaDescription = `Buy GIA & IGI certified natural coloured diamonds for engagement & wedding rings. Rare pink, yellow & green diamonds. FREE & fast Australia wide shipping`;
      }

      // Set document title
      this.pageTitle = metaTitle;
      this.pageDescription = metaDescription;
      document.title = metaTitle;

      // Utility to update or create meta tag
      const updateMetaTag = (attr, name, content) => {
        let tag = document.querySelector(`head meta[${attr}="${name}"]`);
        if (!tag) {
          tag = document.createElement("meta");
          tag.setAttribute(attr, name);
          document.head.appendChild(tag);
        }
        tag.setAttribute("content", content);
      };

      // Update meta tags
      updateMetaTag("name", "title", metaTitle);
      updateMetaTag("name", "description", metaDescription);
      updateMetaTag("property", "og:title", metaTitle);
      updateMetaTag("property", "og:description", metaDescription);
      updateMetaTag("name", "twitter:title", metaTitle);
      updateMetaTag("name", "twitter:description", metaDescription);

      const disDesc = `A ${carat}ct ${this.getDiamondType()?.toLowerCase()} ring strikes the perfect balance between size and sparkle. Ideal for those who want a little more brilliance without a big budget, our collection features elegant and timeless ${carat} carat engagement rings crafted with precision.`;

      return { title: metaTitle, desc: disDesc, carat };
    },
    handleBreadcrumbsShape(shape) {
      if (!shape) {
        return;
      }
      if (!this.isValidShape(shape) && this.isValidCaratPage(shape)) {
        this.setDynamicCaratPageMetaData(shape);
      }
      // handleBreadcrumbs builds the whole trail, shape crumb included.
      this.handleBreadcrumbs(this.$route.params.diamondType);
    },
    setWishlistItemsToStorage(diamonds) {
      if (diamonds.length) {
        localStorage.setItem("wishlistItems", JSON.stringify(diamonds));
      } else {
        localStorage.removeItem("wishlistItems");
      }
    },
    addToWishlist(diamond, e) {
      e.stopPropagation();
      const currentTargetEl = e.currentTarget;
      currentTargetEl.classList.add("pc-wishlist-loading");
      const diamondName = getDiamondTitle(diamond);
      setTimeout(() => {
        currentTargetEl.classList.remove("pc-wishlist-loading");
        currentTargetEl.classList.add("selected");
        if (!this.filters.initialFilters.wishlistItems.includes(diamond.diamondId)) {
          this.filters.initialFilters.wishlistItems.push(diamond.diamondId);
          sessionStorage.setItem("status", "Great choice! This product has been added to your wishlist.");
          sessionStorage.setItem("checkEngageDiaId", diamond.diamondId);
        } else {
          sessionStorage.setItem("status", "Already exist in your wishlist");
        }
        this.setWishlistItemsToStorage(this.filters.initialFilters.wishlistItems);
        this.showWishlistPopup = true;
        this.WishlistPopupContent = {};
        this.wishlistItemName = diamondName.includes("Diamond") ? diamondName : `${diamondName} Diamond`;
      }, 300);
    },
    /* live search by report number — fires while typing, no Search button needed */
    handleCertSearchInput() {
      clearTimeout(this.certSearchTimer);
      this.certSearchTimer = setTimeout(() => {
        var certNumber = (
          this.filters.initialFilters.certificateNumber || ""
        ).trim();
        /* input cleared -> drop the cert filter and re-hit the API for the full list */
        if (!certNumber) {
          this.clearCertSearch();
          return;
        }
        this.showCertError = false;
        this.disableFilter = true;
        /* step slider */
        this.initStepSliders();
        /* step slider */
        this.applyFilters();
      }, 500);
    },
    clearCertSearch() {
      clearTimeout(this.certSearchTimer);
      this.filters.initialFilters.certificateNumber = "";
      this.showCertError = false;
      this.disableFilter = false;
      this.applyFilters();
    },
    searchDiamondByCert() {
      clearTimeout(this.certSearchTimer);
      if (!this.filters.initialFilters.certificateNumber) {
        this.showCertError = true;
        return;
      } else {
        this.showCertError = false;
      }
      if (this.openFilterSection || this.addFilterResultSectionClass) {
        this.openFilterSection = false;
        this.addFilterResultSectionClass = false;
      }
      this.disableFilter = true;
      // this.initializeAllFilters()
      /* step slider */
      this.initStepSliders();
      /* step slider */
      this.applyFilters();
    },
    handleWidthOfSorters() {
      const totalWidth = 100;
      let totalSortCols = 0;
      for (sortField in this.filters.initialFilters.sortFields) {
        if (this.filters.initialFilters.sortFields[sortField].showField) {
          totalSortCols++;
        }
      }
      this.filters.initialFilters.sortColumnsWidth = `${(
        totalWidth / totalSortCols
      ).toFixed(2)}`;
    },
    showAdvanceSortField(e, sortField, filterStateField) {
      if (Array.isArray(this.filters.initialFilters[filterStateField])) {
        if (this.filters.initialFilters[filterStateField].length < 1) {
          this.filters.initialFilters.sortFields[sortField].showField = false;
        } else {
          this.filters.initialFilters.sortFields[sortField].showField = true;
        }
      } else {
        this.filters.initialFilters.sortFields[sortField].showField = true;
      }
      this.handleWidthOfSorters();
    },
    changeListView(e) {
      this.filters.initialFilters.isListView =
        !this.filters.initialFilters.isListView;
      this.saveAppliedFilters();
    },
    toggleFilterDiv(e) {
      if (!this.toggleClass) {
        this.toggleClass = "pc-slide-down";
        this.bannerClass = "pc-hide-banner";
      } else if (this.toggleClass == "pc-slide-down") {
        this.toggleClass = "pc-slide-up";
        this.bannerClass = "pc-show-banner";
      } else {
        this.toggleClass = "pc-slide-down";
        this.bannerClass = "pc-hide-banner";
      }
    },
    removeInpValue(e) {
      e.currentTarget.value = "";
    },
    removeFilter(e, filterType, filterValue = "") {
      if (this.$options.sliderOptions.includes(filterType)) {
        this.hideAdvanceFieldsFromListView(filterType);
        this.handleQueryFilters(filterType, "remove");
        this.filters.initialFilters[filterType].value = [
          filterType == "carat" ? 1 : this.filters[filterType].min,
          this.filters[filterType].max,
        ];
        if (filterType == "price") {
          this.handlePriceFields();
        }
      } else if (filterType == "certificateNumber") {
        /* cancel any pending live search so it can't re-apply the cleared number */
        clearTimeout(this.certSearchTimer);
        this.filters.initialFilters[filterType] = "";
        this.showCertError = false;
        /* cert search had locked the other filters — unlock them again */
        this.disableFilter = false;
      } else if (filterType == "gemstoneDimensions") {
        this.filters.initialFilters.gemstoneLengthMin =
          this.filters.gemstoneDefaultLengthMin;
        this.filters.initialFilters.gemstoneLengthMax =
          this.filters.gemstoneDefaultLengthMax;
        this.filters.initialFilters.gemstoneWidthMin =
          this.filters.gemstoneDefaultWidthMin;
        this.filters.initialFilters.gemstoneWidthMax =
          this.filters.gemstoneDefaultWidthMax;
      } else if (filterType == "gemstoneOrigin") {
        this.filters.initialFilters[filterType] = "Other";
      } else {
        var isRangeFilter = 0;
        if (
          filterType == "color" &&
          !this.$options.rapnetRequestDiamonds.includes(
            this.filters.initialFilters.selectedDiamondTab
          )
        ) {
          isRangeFilter = 0;
        } else if (
          filterType == "diamondShape" ||
          filterType == "fluroscence" ||
          filterType == "labs"
        ) {
          isRangeFilter = 0;
        } else {
          if (
            this.$options.rapnetRequestDiamonds.includes(
              this.filters.initialFilters.selectedDiamondTab
            )
          ) {
            isRangeFilter = 1;
          } else {
            isRangeFilter = 0;
          }
        }
        if (!isRangeFilter) {
          this.filters.initialFilters[filterType] = this.filters.initialFilters[
            filterType
          ].filter((initFilterValue) => {
            return initFilterValue.toLowerCase() != filterValue.toLowerCase();
          });
        } else {
          this.filters.initialFilters[filterType] = [];
        }
        if (this.filters.initialFilters[filterType].length) {
          this.handleQueryFilters(
            filterType == "diamondShape" ? "shape" : filterType,
            "update",
            this.filters.initialFilters[filterType]
          );
        } else {
          this.handleQueryFilters(
            filterType == "diamondShape" ? "shape" : filterType,
            "remove"
          );
        }
        this.hideAdvanceFieldsFromListView(filterType);
      }
      this.applyFilters();
    },

    removeFilters(filterType, filterValue = "") {
      if (filterType === "diamondShape") {
        if (Array.isArray(this.filters.initialFilters[filterType])) {
          this.filters.initialFilters[filterType] =
            !!this.$route.params.shape && this.$route.params.shape != "diamonds"
              ? [
                `${this.$route.params.shape
                  .slice(0, 1)
                  .toUpperCase()}${this.$route.params.shape.slice(1)}`,
              ]
              : [];
          // : ["Round"];
        } else if (
          typeof this.filters.initialFilters[filterType] === "object" &&
          !Array.isArray(this.filters.initialFilters[filterType])
        ) {
          this.filters.initialFilters[filterType] = {};
        } else {
          this.filters.initialFilters[filterType] =
            !!this.$route.params.shape && this.$route.params.shape != "diamonds"
              ? `${this.$route.params.shape
                .slice(0, 1)
                .toUpperCase()}${this.$route.params.shape.slice(1)}`
              : "";
          // : "Round";
        }
      }
      this.applyFilters();
    },
    hideAdvanceFieldsFromListView(field) {
      if (field == "depth") {
        this.filters.initialFilters.sortFields.dept_perc.showField = false;
      } else if (field == "table") {
        this.filters.initialFilters.sortFields.table_perc.showField = false;
      } else if (field == "polish" || field == "symmetry") {
        if (!this.filters.initialFilters[field].length) {
          this.filters.initialFilters.sortFields[field].showField = false;
        }
      } else if (field == "fluroscence") {
        if (!this.filters.initialFilters.fluroscence.length) {
          this.filters.initialFilters.sortFields.flour_intensity.showField = false;
        }
      }
      this.handleWidthOfSorters();
    },
    handleQueryFilters(filter, action, values = []) {
      const query = Object.assign({}, this.$route.query);
      if (action == "remove") {
        delete query[filter];
      } else {
        query[filter] = values.join(",");
      }
      this.$router.replace({ query });
    },
    setSliderValues(e, sliderType, valueType, value = null) {
      var inputValue = !!value ? value : e.currentTarget.value.replace(/[^0-9\.]/g, "");

      if (!inputValue) {
        if (sliderType == "price") {
          inputValue =
            valueType == "min"
              ? this.filters.initialFilters.priceTxtFields.minPrice
              : this.filters.initialFilters.priceTxtFields.maxPrice;
        } else {
          inputValue =
            this.filters.initialFilters[sliderType].value[
            valueType == "min" ? 0 : 1
            ];
        }
      }

      inputValue =
        sliderType === "price"
          ? Math.round(parseInt(inputValue))
          : parseFloat(inputValue);

      if (valueType == "min") {
        if (sliderType == "price") {
          var inputMinPrice = inputValue;
          if (
            inputMinPrice < this.defaultMinPrice ||
            inputMinPrice > this.defaultMaxPrice
          ) {
            inputMinPrice = this.getPriceByArrayIndex(
              this.filters.initialFilters[sliderType].value[0]
            );
          }
          this.filters.initialFilters[sliderType].value[0] =
            this.getArrayIndexByPrice(inputMinPrice);
          if (
            this.filters.initialFilters.priceTxtFields.minPrice != inputMinPrice
          ) {
            sessionStorage.setItem("storedMinPrice", inputMinPrice);
          }
          this.filters.initialFilters.priceTxtFields.minPrice = inputMinPrice;
        } else {
          if (
            inputValue < this.filters[sliderType].min ||
            inputValue > this.filters[sliderType].max
          ) {
            inputValue = this.filters[sliderType].min;
          }
          if (inputValue == this.filters.initialFilters[sliderType].value[0]) {
            e.currentTarget.value =
              sliderType !== "price"
                ? this.filters.initialFilters[sliderType].value[0] +
                " " +
                this.filters[sliderType].symbol
                : this.filters[sliderType].symbol +
                " " +
                this.filters.initialFilters[
                  sliderType
                ].value[0].toLocaleString("en-US");
            return;
          }
          this.filters.initialFilters[sliderType].value[0] = inputValue;
        }
      } else if (valueType == "max") {
        if (sliderType == "price") {
          var inputMaxPrice = inputValue;
          if (
            inputMaxPrice > this.defaultMaxPrice ||
            inputMaxPrice < this.defaultMinPrice
          ) {
            inputMaxPrice = this.getPriceByArrayIndex(
              this.filters.initialFilters[sliderType].value[1]
            );
          }
          this.filters.initialFilters[sliderType].value[1] =
            this.getArrayIndexByPrice(inputMaxPrice);
          if (
            this.filters.initialFilters.priceTxtFields.maxPrice != inputMaxPrice
          ) {
            sessionStorage.setItem("storedMaxPrice", inputMaxPrice);
          }
          this.filters.initialFilters.priceTxtFields.maxPrice = inputMaxPrice;
        } else {
          if (
            inputValue > this.filters[sliderType].max ||
            inputValue < this.filters[sliderType].min
          ) {
            inputValue = this.filters[sliderType].max;
          }
          if (inputValue == this.filters.initialFilters[sliderType].value[1]) {
            e.currentTarget.value =
              sliderType !== "price"
                ? this.filters.initialFilters[sliderType].value[1] +
                " " +
                this.filters[sliderType].symbol
                : this.filters[sliderType].symbol +
                " " +
                this.filters.initialFilters[
                  sliderType
                ].value[1].toLocaleString("en-US");
            return;
          }
          this.filters.initialFilters[sliderType].value[1] = inputValue;
        }
      }
      this.applyFilters();
    },
    initializeAllFilters(isResetRequest = 0) {
      var mainFiltersJson = this.filters;
      var initialFiltersJson = mainFiltersJson.initialFilters;
      for (initialFilter in initialFiltersJson) {
        if (initialFilter == "isListView" || initialFilter == "wishlistItems")
          continue;
        if (initialFilter == "certificateNumber") {
          initialFiltersJson[initialFilter] = "";
        } else if (Array.isArray(initialFiltersJson[initialFilter])) {
          initialFiltersJson[initialFilter] = [];
        } else if (typeof initialFiltersJson[initialFilter] == "string") {
          if (
            initialFilter != "diamondShape" &&
            initialFilter != "selectedDiamondTab" &&
            initialFilter !== "certificateNumber"
          ) {
            initialFiltersJson[initialFilter] = "";
          } else if (initialFilter == "diamondShape") {
            initialFiltersJson[initialFilter] =
              !!this.$route.params.shape &&
                this.$route.params.shape != "diamonds"
                ? `${this.$route.params.shape
                  .slice(0, 1)
                  .toUpperCase()}${this.$route.params.shape.slice(1)}`
                : "";
            // : "Round";
          }
        } else if (initialFilter == "sortby") {
          initialFiltersJson[initialFilter] = {
            type: "final_price",
            dir: "ASC",
          };
        } else if (this.$options.sliderOptions.includes(initialFilter)) {
          if (initialFilter.toLowerCase() != "carat") {
            initialFiltersJson[initialFilter] = {
              value: [
                mainFiltersJson[initialFilter].min,
                mainFiltersJson[initialFilter].max,
              ],
            };
            if (initialFilter == "price") {
              this.handlePriceFields();
            }
          } else {
            if (this.isValidCaratPage(this.$route.params.shape)) {
              const carat = this.parseCaratValue(this.$route.params.shape);
              if (Number(carat)) {
                initialFiltersJson["carat"] = {
                  value: [Number(carat), mainFiltersJson[initialFilter].max],
                };
              }
            } else {
              initialFiltersJson["carat"] = {
                value: [1, mainFiltersJson[initialFilter].max],
              };
            }
          }
        } else if (initialFilter == "sortFields") {
          for (sortField in initialFiltersJson[initialFilter]) {
            if (initialFiltersJson[initialFilter][sortField].isAdvance) {
              initialFiltersJson[initialFilter][sortField].showField = false;
            }
            initialFiltersJson[initialFilter][sortField].dir = "ASC";
          }
          this.handleWidthOfSorters();
        } else if (initialFilter == "certificateNumber" && isResetRequest) {
          initialFiltersJson[initialFilter] = "";
        } else if (
          initialFilter == "gemstoneLengthMin" ||
          initialFilter == "gemstoneWidthMin"
        ) {
          initialFiltersJson[initialFilter] =
            this.filters.gemstoneDefaultLengthMin;
        } else if (
          initialFilter == "gemstoneLengthMax" ||
          initialFilter == "gemstoneWidthMax"
        ) {
          initialFiltersJson[initialFilter] =
            this.filters.gemstoneDefaultLengthMax;
        } else if (initialFilter == "gemstoneOrigin") {
          initialFiltersJson[initialFilter] = "Other";
        }
      }
      this.showCertError = false;
    },
    resetFilters(event) {
      this.disableFilter = false;
      this.showAdvancedSearch = false;
      this.initializeAllFilters(2);
      /* step slider */
      this.initStepSliders();
      /* step slider */
      this.applyFilters();
    },
    /* step slider */
    initStepSliders() {
      if (this.displayStepSlider) {
        this.$options.stepSliderOptions.forEach((stepSliderFilterOption) => {
          this.filters.initialFilters[stepSliderFilterOption].value = [
            this.filters[stepSliderFilterOption].min,
            this.filters[stepSliderFilterOption].max,
          ];
        });
      }
    },
    /* step slider */
    injectAppliedFilters() {
      var appliedFilters = sessionStorage.getItem(
        `${this.filters.initialFilters.selectedDiamondTab}DiamondsAppliedFilters`
      );
      if (appliedFilters != null) {
        this.filters.initialFilters = JSON.parse(appliedFilters);
      }
      if (localStorage.getItem("wishlistItems") != null) {
        this.filters.initialFilters.wishlistItems = JSON.parse(
          localStorage.getItem("wishlistItems")
        );
      }
      // this.injectWishlistDiamondsFromCookie()
    },
    injectWishlistDiamondsFromCookie() {
      if (wishlistDiamondIds.length) {
        var nonExistWishlistDiamondIds = wishlistDiamondIds.filter(
          (wishlistDiamondId) => {
            if (
              !this.filters.initialFilters.wishlistItems.includes(
                wishlistDiamondId
              )
            ) {
              return wishlistDiamondId;
            }
          }
        );
        this.filters.initialFilters.wishlistItems.push(
          ...nonExistWishlistDiamondIds
        );
      }
    },
    saveAppliedFilters(filter = undefined) {
      sessionStorage.setItem(
        `${this.filters.initialFilters.selectedDiamondTab}DiamondsAppliedFilters`,
        JSON.stringify(this.filters.initialFilters)
      );
      if (filter == "shape") {
        this.changeRouterShape(this.filters.initialFilters.diamondShape);
      }
    },
    applyFilters(filter = undefined) {
      this.changeGridTab("diamond");
      this.handleCutFilter();
      this.shouldShowAppliedFilters();
      this.page = 1;
      this.items = [];
      this.saveAppliedFilters(filter);
      /* remove diamondlist and current page from cached session before load new diamonds from ajax */
      this.removeDiamondMetaData();
      this.loadMore();
    },
    removeDiamondMetaData() {
      this.removeCurrentPageFromSession();
      this.removeDiamondsFromSession();
      this.removeDiamondCountFromSession();
    },
    handleCutFilter() {
      if (
        !!this.filters.initialFilters.diamondShape &&
        this.filters.initialFilters.diamondShape.includes("Round")
      ) {
        // this.showCutFilterSection = true
        // this.filters.initialFilters.sortFields.cut.showField = true
        // this.filters.initialFilters.cut = []
        this.showCutFilterSection = true;
        this.filters.initialFilters.sortFields.cut.showField = true;
      } else if (
        1 != 1 &&
        this.filters.initialFilters.diamondShape.length == 1 &&
        this.filters.initialFilters.diamondShape.includes("Round")
      ) {
        this.showCutFilterSection = true;
        this.filters.initialFilters.sortFields.cut.showField = true;
      } else {
        this.showCutFilterSection = false;
        this.filters.initialFilters.cut = [];
        this.filters.initialFilters.sortFields.cut.showField = false;
      }
    },
    shouldShowAppliedFilters() {
      for (let filter of this.$options.regularFilters) {
        if (Array.isArray(this.filters.initialFilters[filter])) {
          if (this.filters.initialFilters[filter].length) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (
          this.$options.sliderOptions.includes(filter) &&
          filter != "price"
        ) {
          if (
            this.filters.initialFilters[filter].value[0] !=
            this.filters[filter].min ||
            this.filters.initialFilters[filter].value[1] !=
            this.filters[filter].max
          ) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (filter == "price") {
          if (
            this.filters.initialFilters.priceTxtFields.minPrice !=
            this.defaultMinPrice ||
            this.filters.initialFilters.priceTxtFields.maxPrice !=
            this.defaultMaxPrice
          ) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (
          filter == "gemstoneLengthMin" ||
          filter == "gemstoneLengthMax" ||
          filter == "gemstoneWidthMin" ||
          filter == "gemstoneWidthMax"
        ) {
          if (this.showGemstoneDimensionsAppliedFilterSection) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (filter == "gemstoneOrigin") {
          if (
            !!this.filters.initialFilters.gemstoneOrigin &&
            this.filters.initialFilters.gemstoneOrigin.toLowerCase() != "other"
          ) {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        } else if (typeof this.filters.initialFilters[filter] == "string") {
          if (this.filters.initialFilters[filter] != "") {
            this.filters.initialFilters.showAppliedFiltersSection = true;
            return;
          } else {
            this.filters.initialFilters.showAppliedFiltersSection = false;
          }
        }
      }
    },
    clearOldRequest() {
      this.request = null;
    },
    cancelRequest() {
      this.request.cancel();
      this.request = null;
    },
    loadMore() {
      this.loading = true;
      this.sendRequest = false;
      this.dataNotFound = false;
      if (this.request) this.cancelRequest();
      const axiosSource = axios.CancelToken.source();
      this.request = { cancel: axiosSource.cancel };
      if (
        !this.$options.rapnetRequestDiamonds.includes(
          this.filters.initialFilters.selectedDiamondTab
        )
      ) {
        if (this.filters.initialFilters.certificateNumber) {
          axios({
            url: api,
            method: "post",
            cancelToken: axiosSource.token,
            data: {
              query: `{
                            ${diamondDetailApiFunc}(diamondId:"${this.filters.initialFilters.certificateNumber
                }",diamondType:"${this.filters.initialFilters.selectedDiamondTab
                }") {
                                diamond{
                                       diamondId
                                       shape
                                       caratWeight                                              
                                       color
                                       clarity
                                       cut
                                       symmetry
                                       polish
                                       deptPerc
                                       tablePerc
                                       length
                                       width
                                       depth
                                       ratio
                                       girdleMin
                                       girdleMax                       
                                       culet                       
                                       fancyColor
                                       flourIntensity                       
                                       certificateFile
                                       lab                                              
                                       ${graphQLCurrencyFields()}
                                       certificateNumber
                                       stockNumber
                                       diamondImage 
                                       diamondVideo                       
                                       diamondType
                                       currencyCode
                                       currencySymbol
                                    }
                                }
                            }`,
            },
          })
            .then((response) => {
              this.clearOldRequest();
              if (response.data.data[diamondDetailApiFunc].diamond.length) {
                var diamondList = this.getConvertedDiamonds(
                  response.data.data[diamondDetailApiFunc].diamond
                );
                // (this.items.length == 0 || this.items.some(v=>v.diamondId == diamondList.diamondId)) &&
                this.items = diamondList;
                this.diamondCount =
                  response.data.data[diamondDetailApiFunc].diamond.length;
                if (!(parseInt(this.diamondCount) - this.items.length > 0)) {
                  document.removeEventListener("scroll", this.handleScroll);
                } else {
                  this.page += 1;
                  window.addEventListener("scroll", () => {
                    this.sendRequestOnWindowScroll();
                    this.makeListHeaderSticky();
                  });
                }
                this.loading = false;
                this.dataNotFound = false;
                /* save current page, diamonds and diamond count to session */
                this.saveCurrentPageToSession(this.page);
                this.saveDiamondsToSession(diamondList);
                this.saveDiamondCountToSession(this.diamondCount);
              } else {
                this.loading = false;
                this.dataNotFound = true;
                this.diamondCount = 0;
                this.page = 1;
                this.items = [];
              }
              this.sendRequest = true;
            })
            .catch((err) => {
              if (err.toString().toLowerCase() == "cancel") {
                this.dataNotFound = false;
              } else {
                this.dataNotFound = true;
                this.diamondCount = 0;
                this.page = 1;
                this.items = [];
              }
              this.sendRequest = true;
            });
        } else {
          /* price filter values */
          var minAppliedPrice =
            this.filters.initialFilters.priceTxtFields.minPrice;
          var maxAppliedPrice =
            this.filters.initialFilters.priceTxtFields.maxPrice;

          /* reverse the 30% display discount for lab/lab_color when min price >= 500
             displayed price = finalPriceAud * 0.7, so API needs displayedPrice / 0.7 */
          var _tab = this.filters.initialFilters.selectedDiamondTab;
          if (
            (_tab === "lab" || _tab === "lab_color") &&
            parseInt(minAppliedPrice) >= 500
          ) {
            minAppliedPrice = Math.round(parseInt(minAppliedPrice) / 0.7);
            maxAppliedPrice = Math.round(parseInt(maxAppliedPrice) / 0.7);
          }
          /* price filter values */

          /* dimensions filter values */
          var appliedLengthMin = this.filters.initialFilters.gemstoneLengthMin;
          var appliedLengthMax = this.filters.initialFilters.gemstoneLengthMax;
          var appliedWidthMin = this.filters.initialFilters.gemstoneWidthMin;
          var appliedWidthMax = this.filters.initialFilters.gemstoneWidthMax;
          /* dimensions filter values */

          var graphqlSortField = this.filters.initialFilters.sortby.type;
          if (graphqlSortField == "final_price") {
            graphqlSortField = getCurrencyWiseSortField();
          }

          if (this.filters.initialFilters.selectedDiamondTab == "gemstone") {
            axios({
              url: api,
              method: "post",
              cancelToken: axiosSource.token,
              data: {
                query: `{ 
                                        ${gemstoneListApiFunc}(shapes:"${this.filters.initialFilters.diamondShape}",color:"${this.filters.initialFilters.color}",weightCarat:"") {
                                            dataCount
                                            pageNo
                                            gemstone {
                                                diamondId
                                                stoneType
                                                shape
                                                color
                                                cut
                                                caratWeight
                                                clarity
                                                length
                                                width
                                                height
                                                diamondImage
                                                diamondVideo
                                                location  
                                                finalPrice
                                                finalPriceEur                                                
                                                diamondType
                                                certificateNumber
                                                lab
                                                certificateFile
                                                treatment
                                                currencyCode
                                                currencySymbol
                                            }
                                        }
                                    }`,
              },
            })
              .then((response) => {
                this.clearOldRequest();
                if (response.data.data[gemstoneListApiFunc].gemstone.length) {
                  var diamondList = this.getConvertedDiamonds(
                    response.data.data[gemstoneListApiFunc].gemstone
                  );
                  this.items.push(...diamondList);
                  this.diamondCount =
                    response.data.data[gemstoneListApiFunc].dataCount;
                  /*                                 if (!((parseInt(this.diamondCount)-this.items.length) > 0)){
                                } */
                  if (!(parseInt(this.diamondCount) - this.items.length > 0)) {
                    document.removeEventListener("scroll", this.handleScroll);
                  } else {
                    this.page += 1;
                    window.addEventListener("scroll", () => {
                      this.sendRequestOnWindowScroll();
                      this.makeListHeaderSticky();
                    });
                  }
                  this.loading = false;
                  this.dataNotFound = false;
                  /* save current page, diamonds and diamond count to session */
                  this.saveCurrentPageToSession(this.page);
                  this.saveDiamondsToSession(diamondList);
                  this.saveDiamondCountToSession(this.diamondCount);
                } else {
                  this.loading = false;
                  this.dataNotFound = true;
                  this.diamondCount = 0;
                  this.page = 1;
                  this.items = [];
                }
                this.sendRequest = true;
              })
              .catch((err) => {
                if (err.toString().toLowerCase() == "cancel") {
                  this.dataNotFound = false;
                } else {
                  this.dataNotFound = true;
                  this.diamondCount = 0;
                  this.page = 1;
                  this.items = [];
                }
                this.sendRequest = true;
              });
          } else {
            // this.page += 1
            var shapes =
              this.filters.initialFilters.diamondShape.length > 0
                ? Array.isArray(this.filters.initialFilters.diamondShape)
                  ? this.filters.initialFilters.diamondShape.join(",")
                  : this.filters.initialFilters.diamondShape
                : this.settingCanBeSetWithShapes.join(",");
            // var shapes = !!this.filters.initialFilters.diamondShape.length ? this.filters.initialFilters.diamondShape.join(",") : (!!sessionStorage.getItem('selectedSetting') && JSON.parse(sessionStorage.getItem('selectedSetting')).sku.split('-')[JSON.parse(sessionStorage.getItem('selectedSetting')).sku.split('-').length - 1])
            //
            axios({
              url: api,
              method: "post",
              cancelToken: axiosSource.token,
              data: {
                query:
                  `{
                        ${diamondListApiFunc}(page: "` +
                  this.page +
                  `", shapes:"` +
                  shapes +
                  `", ${this.filters.initialFilters.selectedDiamondTab ===
                    "white_color" ||
                    this.filters.initialFilters.selectedDiamondTab ===
                    "lab_color"
                    ? "fancyColor"
                    : "color"
                  }:"` +
                  (this.filters.initialFilters.selectedDiamondTab ===
                    "white_color" ||
                    this.filters.initialFilters.selectedDiamondTab === "lab_color"
                    ? this.filters.initialFilters.fancyColor
                    : this.filters.initialFilters.color) +
                  `", colorflag:"` +
                  `${this.filters.initialFilters.selectedDiamondTab ===
                    "white_color" ||
                    this.filters.initialFilters.selectedDiamondTab ===
                    "lab_color"
                    ? "fancy"
                    : ""
                  }` +
                  `", carat:"` +
                  this.filters.initialFilters.carat.value[0] +
                  `, ` +
                  this.filters.initialFilters.carat.value[1] +
                  `", clarity:"` +
                  this.filters.initialFilters.clarity +
                  `", symmetry:"` +
                  this.filters.initialFilters.symmetry +
                  `", polish:"` +
                  this.filters.initialFilters.polish +
                  `", price:"` +
                  minAppliedPrice +
                  `, ` +
                  maxAppliedPrice +
                  `", table:"` +
                  parseFloat(
                    this.filters.initialFilters.table.value[0]
                  ).toFixed(2) +
                  `, ` +
                  parseFloat(
                    this.filters.initialFilters.table.value[1]
                  ).toFixed(2) +
                  `", depthPer:"` +
                  parseFloat(
                    this.filters.initialFilters.depth.value[0]
                  ).toFixed(2) +
                  `, ` +
                  parseFloat(
                    this.filters.initialFilters.depth.value[1]
                  ).toFixed(2) +
                  `", ratio:"` +
                  parseFloat(
                    this.filters.initialFilters.ratio.value[0]
                  ).toFixed(2) +
                  `, ` +
                  parseFloat(
                    this.filters.initialFilters.ratio.value[1]
                  ).toFixed(2) +
                  `", cut:"` +
                  this.filters.initialFilters.cut +
                  `", fluoroscence:"` +
                  this.filters.initialFilters.fluroscence +
                  `", lab:"` +
                  this.filters.initialFilters.labs +
                  `", diamondType:"` +
                  this.filters.initialFilters.selectedDiamondTab +
                  `", sortBy:"` +
                  this.filters.initialFilters.sortby.dir +
                  `", orderBy:"` +
                  graphqlSortField +
                  `", length:"${appliedLengthMin},${appliedLengthMax}", width:"${appliedWidthMin},${appliedWidthMax}", currencyFlag:"${currencyCode}")
                      {
                         dataCount
                         diamondsReturned
                         pageNo
                         diamond{
                           diamondId
                           shape
                           caratWeight                                              
                           color
                           clarity
                           cut
                           symmetry
                           polish
                           deptPerc
                           tablePerc
                           length
                           width
                           depth
                           ratio
                           girdleMin
                           girdleMax                       
                           culet                       
                           fancyColor
                           flourIntensity                       
                           certificateFile
                            ${graphQLCurrencyFields()}
                           lab                                              
                           finalPriceUsd
                           finalPriceAud
                           finalPriceEur
                           finalPriceGbp
                           certificateNumber
                           stockNumber
                           diamondImage 
                           diamondVideo                       
                           diamondType
                           currencyCode
                           currencySymbol
                         }
                        }
                        }
                        `,
              },
            })
              .then((response) => {
                this.clearOldRequest();
                if (response.data.data[diamondListApiFunc].diamond.length) {
                  var diamondList = this.getConvertedDiamonds(
                    response.data.data[diamondListApiFunc].diamond
                  );

                  if (this.page == 1) {
                    this.items = [];
                  }
                  this.items.push(...diamondList);
                  this.diamondCount =
                    response.data.data[diamondListApiFunc].dataCount;

                  if (!(parseInt(this.diamondCount) - this.items.length > 0)) {
                    document.removeEventListener("scroll", this.handleScroll);
                  } else {
                    this.page += 1;
                    window.addEventListener("scroll", () => {
                      this.sendRequestOnWindowScroll();
                      this.makeListHeaderSticky();
                    });
                  }
                  this.loading = false;
                  this.dataNotFound = false;
                  /* save current page, diamonds and diamond count to session */
                  this.saveCurrentPageToSession(this.page);
                  this.saveDiamondsToSession(diamondList);
                  this.saveDiamondCountToSession(this.diamondCount);
                } else {
                  this.loading = false;
                  this.dataNotFound = true;
                  this.diamondCount = 0;
                  this.page = 1;
                  this.items = [];
                }
                this.sendRequest = true;
              })
              .catch((err) => {
                if (err.toString().toLowerCase() == "cancel") {
                  this.dataNotFound = false;
                } else {
                  this.dataNotFound = true;
                  this.diamondCount = 0;
                  this.page = 1;
                  this.items = [];
                }
                this.sendRequest = true;
              });
          }
        }
      }

      /* if( this.diamondCount < 20){
                console.log("remove:- ", this.diamondCount)
                document.removeEventListener('scroll',this.handleScroll)
            } else{
                console.log("add:- ", this.diamondCount)
                window.addEventListener("scroll", () => {
                    this.sendRequestOnWindowScroll()
                    this.makeListHeaderSticky()
                })
            } */
    },
    getConvertedDiamonds(diamonds) {
      var convertedDiamonds = [];
      diamonds.forEach((diamond) => {
        diamond = this.appendGemstoneFieldsInDiamondData(diamond);
        diamond = getCurrencyWiseDiamond(diamond);
        convertedDiamonds.push(diamond);
      });
      return convertedDiamonds;
    },
    appendGemstoneFieldsInDiamondData(diamond) {
      if (this.filters.initialFilters.selectedDiamondTab == "gemstone") {
        if (diamond.hasOwnProperty("height")) {
          diamond["depth"] = diamond.height;
        }
      }
      return diamond;
    },
    getDiamondSessionVariable() {
      return `${this.filters.initialFilters.selectedDiamondTab}DiamondList`;
    },
    getPageSessionVariable() {
      return `${this.filters.initialFilters.selectedDiamondTab}CurrentPage`;
    },
    getDiamondCountVariable() {
      return `${this.filters.initialFilters.selectedDiamondTab}DiamondCount`;
    },
    saveDiamondsToSession(diamonds) {
      var diamondList = [];
      if (sessionStorage.getItem(this.getDiamondSessionVariable())) {
        diamondList = JSON.parse(
          sessionStorage.getItem(this.getDiamondSessionVariable())
        );
        diamondList.push(...diamonds);
      } else {
        diamondList.push(...diamonds);
      }
      sessionStorage.setItem(
        this.getDiamondSessionVariable(),
        JSON.stringify(diamondList)
      );
    },
    saveCurrentPageToSession(curPage) {
      sessionStorage.setItem(this.getPageSessionVariable(), curPage);
    },
    saveDiamondCountToSession(diamondCount) {
      sessionStorage.setItem(this.getDiamondCountVariable(), diamondCount);
    },
    getCurrentPageFromSession() {
      return sessionStorage.getItem(this.getPageSessionVariable());
    },
    getDiamondsFromSession() {
      var diamondList = [];
      if (sessionStorage.getItem(this.getDiamondSessionVariable())) {
        diamondList = JSON.parse(
          sessionStorage.getItem(this.getDiamondSessionVariable())
        );
      }
      return diamondList;
    },
    getDiamondCountFromSession() {
      return sessionStorage.getItem(this.getDiamondCountVariable());
    },
    removeCurrentPageFromSession() {
      if (sessionStorage.getItem(this.getPageSessionVariable())) {
        sessionStorage.removeItem(this.getPageSessionVariable());
      }
    },
    removeDiamondsFromSession() {
      if (sessionStorage.getItem(this.getDiamondSessionVariable())) {
        sessionStorage.removeItem(this.getDiamondSessionVariable());
      }
    },
    removeDiamondCountFromSession() {
      if (sessionStorage.getItem(this.getDiamondCountVariable())) {
        sessionStorage.removeItem(this.getDiamondCountVariable());
      }
    },
    getFancyDiamondsSelectedSortField() {
      if (this.filters.initialFilters.sortby.type == "carat_weight") {
        return "Size";
      } else if (this.filters.initialFilters.sortby.type == "final_price") {
        return "Price";
      } else {
        return (
          this.filters.initialFilters.sortby.type
            .toLowerCase()
            .charAt(0)
            .toUpperCase() +
          this.filters.initialFilters.sortby.type.toLowerCase().slice(1)
        );
      }
    },
    applySort(sortType, sortDir) {
      this.filters.initialFilters.sortby.type = sortType;
      this.filters.initialFilters.sortby.dir = sortDir;
      for (var sortField in this.filters.initialFilters.sortFields) {
        if (sortField == sortType) {
          this.filters.initialFilters.sortFields[sortField].dir = sortDir;
        } else {
          this.filters.initialFilters.sortFields[sortField].dir = "ASC";
        }
      }
      this.applyFilters();
    },
    getPageUrl() {
      return document.URL;
    },
    getMetaData(type) {
      var diamondType = this.$route.params.diamondType;
      switch (type) {
        case "description":
          return this.$options.metadataDescr[diamondType];
        case "title":
          var title = diamondType
            .split("-")
            .map((title) => {
              if (title == "lab" || title == "lab_color") {
                return "Lab Grown";
              } else if (title == "fancy") {
                return "Coloured";
              } else {
                return (
                  title.charAt(0).toUpperCase() + title.toLowerCase().slice(1)
                );
              }
            })
            .join(" ");
          return title;
        case "siteName":
          return "Vue Woocomerce";
        case "type":
          return "website";
      }
    },
    handleMetaData() {
      // document.title = this.$t(this.getMetaData("title"))
      /* set default and openGraph meta data for filter page */
      const meta = [
        { name: "description", content: this.getMetaData("description") },
        { property: "og:title", content: this.getMetaData("title") },
        { property: "og:site_name", content: this.getMetaData("siteName") },
        { property: "og:type", content: this.getMetaData("type") },
        { property: "og:url", content: this.getPageUrl() },
        {
          property: "og:description",
          content: this.getMetaData("description"),
        },
      ];
      const link = [{ rel: "canonical", href: this.getPageUrl() }];
      // setMetaData("meta", meta)
      // setMetaData("link", link)
    },
  },
  beforeRouteEnter(to, from) {
    if (sessionStorage.getItem("firstPage")) {
      var firstPage = sessionStorage.getItem("firstPage");
      if (firstPage == "settingPage") {
        resetRingFromSession("notSelected");
      }
    }
    if (sessionStorage.getItem("selectedSetting") === null) {
      sessionStorage.setItem("firstPage", "diamondPage");
    }
  },
  beforeMount() {
    document.getElementById("initial-page-loader").style.display = "none";
    let elements = document.getElementsByClassName("js-recently-view");
    for (let i = 0; i < elements.length; i++) {
      elements[i].style.display = "block";
    }
  },
};
